var rn = Object.defineProperty;
var ln = (e, t, n) => t in e ? rn(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var te = (e, t, n) => ln(e, typeof t != "symbol" ? t + "" : t, n);
import D, { createContext as Ae, useContext as we, useState as M, useCallback as k, useEffect as y, useRef as F, useMemo as S, useLayoutEffect as cn, useDebugValue as an, Suspense as sn, lazy as vt, useSyncExternalStore as Ze, forwardRef as dn, useImperativeHandle as un, useReducer as mn } from "react";
import { jsxs as H, jsx as l, Fragment as N } from "react/jsx-runtime";
import { CommentsExtension as G } from "@blocknote/core/comments";
import { FilePanelExtension as he, LinkToolbarExtension as ke, VALID_LINK_PROTOCOLS as fn, DEFAULT_LINK_PROTOCOL as hn, FormattingToolbarExtension as ne, ShowSelectionExtension as gn, TableHandlesExtension as L, SuggestionMenu as X, SideMenuExtension as W, getDefaultEmojiPickerItems as bn, getDefaultSlashMenuItems as pn, filterSuggestionItems as Cn } from "@blocknote/core/extensions";
import { useFloating as De, autoUpdate as vn, useTransitionStyles as Fe, useTransitionStatus as wn, useDismiss as kn, useHover as Hn, useInteractions as xn, useMergeRefs as yn, offset as j, flip as Q, shift as ce, safePolygon as Sn, size as re } from "@floating-ui/react";
import { filenameFromURL as et, getNodeById as Ge, formatKeyboardShortcut as He, isTableCellSelection as Vn, blockHasType as A, editorHasBlockWithType as J, defaultProps as fe, mapTableCell as ie, mergeCSSClasses as Z, EMPTY_CELL_WIDTH as Mn, EMPTY_CELL_HEIGHT as Tn, isTableCell as le, getColspan as wt, getRowspan as kt, getBlockFromPos as _n, camelToDataKebab as Ht, audioParse as Bn, createAudioBlockConfig as En, fileParse as Ln, createFileBlockConfig as Rn, imageParse as On, createImageBlockConfig as In, getPageBreakSlashMenuItems as Pn, videoParse as Nn, createVideoBlockConfig as An, defaultToggledState as ae, UnreachableCaseError as xt, BlockNoteEditor as Zn, BlockNoteSchema as Dn, defaultStyleSpecs as Fn, createParagraphBlockSpec as Gn, nodeToCustomInlineContent as tt, inlineContentToNodes as zn, addInlineContentAttributes as Un, getInlineContentParseRules as jn, addInlineContentKeyboardShortcuts as $n, propsToAttributes as Wn, createInternalInlineContentSpec as qn, addStyleAttributes as Ve, getStyleParseRules as Kn, stylePropsToAttributes as Xn, createInternalStyleSpec as Yn } from "@blocknote/core";
import { useStore as Jn } from "@tanstack/react-store";
import { posToDOMRect as Qn, Node as eo } from "@tiptap/core";
import { createPortal as ze, flushSync as yt } from "react-dom";
import { ReactNodeViewRenderer as St, useReactNodeView as Vt, NodeViewWrapper as Mt, Mark as to, ReactMarkViewRenderer as no, ReactMarkViewContext as oo } from "@tiptap/react";
import { createRoot as ro } from "react-dom/client";
const Tt = Ae(void 0);
function q(e) {
  return we(Tt);
}
const io = Ae(
  void 0
);
function v() {
  return we(io);
}
function C(e) {
  const t = q();
  if (!(t != null && t.editor))
    throw new Error(
      "useBlockNoteEditor was called outside of a BlockNoteContext provider or BlockNoteView component"
    );
  return t.editor;
}
function V() {
  return q().editor.dictionary;
}
const lo = (e) => {
  const t = v(), n = V(), o = C(), r = o.getBlock(e.blockId), [i, c] = M(""), s = k(
    (u) => {
      c(u.currentTarget.value);
    },
    []
  ), a = k(
    (u) => {
      u.key === "Enter" && (u.preventDefault(), o.updateBlock(r.id, {
        props: {
          name: et(i),
          url: i
        }
      }));
    },
    [o, r.id, i]
  ), d = k(() => {
    o.updateBlock(r.id, {
      props: {
        name: et(i),
        url: i
      }
    });
  }, [o, r.id, i]);
  return /* @__PURE__ */ H(t.FilePanel.TabPanel, { className: "bn-tab-panel", children: [
    /* @__PURE__ */ l(
      t.FilePanel.TextInput,
      {
        className: "bn-text-input",
        placeholder: n.file_panel.embed.url_placeholder,
        value: i,
        onChange: s,
        onKeyDown: a,
        "data-test": "embed-input"
      }
    ),
    /* @__PURE__ */ l(
      t.FilePanel.Button,
      {
        className: "bn-button",
        onClick: d,
        "data-test": "embed-input-button",
        children: n.file_panel.embed.embed_button[r.type] || n.file_panel.embed.embed_button.file
      }
    )
  ] });
}, co = (e) => {
  var m, f;
  const t = v(), n = V(), { setLoading: o } = e, r = C(), i = r.getBlock(e.blockId), [c, s] = M(!1);
  y(() => {
    c && setTimeout(() => {
      s(!1);
    }, 3e3);
  }, [c]);
  const a = k(
    (h) => {
      if (h === null)
        return;
      async function g(b) {
        if (o(!0), r.uploadFile !== void 0)
          try {
            let p = await r.uploadFile(b, e.blockId);
            typeof p == "string" && (p = {
              props: {
                name: b.name,
                url: p
              }
            }), r.updateBlock(e.blockId, p);
          } catch {
            s(!0);
          } finally {
            o(!1);
          }
      }
      g(h);
    },
    [e.blockId, r, o]
  ), d = r.schema.blockSpecs[i.type], u = (f = (m = d.implementation.meta) == null ? void 0 : m.fileBlockAccept) != null && f.length ? d.implementation.meta.fileBlockAccept.join(",") : "*/*";
  return /* @__PURE__ */ H(t.FilePanel.TabPanel, { className: "bn-tab-panel", children: [
    /* @__PURE__ */ l(
      t.FilePanel.FileInput,
      {
        className: "bn-file-input",
        "data-test": "upload-input",
        accept: u,
        placeholder: n.file_panel.upload.file_placeholder[i.type] || n.file_panel.upload.file_placeholder.file,
        value: null,
        onChange: a
      }
    ),
    c && /* @__PURE__ */ l("div", { className: "bn-error-text", children: n.file_panel.upload.upload_error })
  ] });
}, _t = (e) => {
  const t = v(), n = V(), o = C(), [r, i] = M(!1), c = e.tabs ?? [
    ...o.uploadFile !== void 0 ? [
      {
        name: n.file_panel.upload.title,
        tabPanel: /* @__PURE__ */ l(co, { blockId: e.blockId, setLoading: i })
      }
    ] : [],
    {
      name: n.file_panel.embed.title,
      tabPanel: /* @__PURE__ */ l(lo, { blockId: e.blockId })
    }
  ], [s, a] = M(
    e.defaultOpenTab || c[0].name
  );
  return /* @__PURE__ */ l(
    t.FilePanel.Root,
    {
      className: "bn-panel",
      defaultOpenTab: s,
      openTab: s,
      setOpenTab: a,
      tabs: c,
      loading: r
    }
  );
};
function ao(e) {
  let t = new DOMRect();
  const n = "getBoundingClientRect" in e ? () => e.getBoundingClientRect() : () => e.element.getBoundingClientRect();
  return () => "element" in e && (e.cacheMountedBoundingClientRect ?? !0) ? (e.element.isConnected && (t = n()), t) : n();
}
const U = (e) => {
  var g, b, p;
  const { refs: t, floatingStyles: n, context: o } = De({
    whileElementsMounted: vn,
    ...e.useFloatingOptions
  }), { isMounted: r, styles: i } = Fe(
    o,
    e.useTransitionStylesProps
  ), { status: c } = wn(
    o,
    e.useTransitionStatusProps
  ), s = kn(o, e.useDismissProps), a = Hn(o, { enabled: !1, ...e.useHoverProps }), { getFloatingProps: d } = xn([s, a]), u = F(""), m = F(null), f = yn([m, t.setFloating]);
  if (y(() => {
    e.reference && ("element" in e.reference && t.setReference(e.reference.element), t.setPositionReference({
      getBoundingClientRect: ao(
        e.reference
      )
    }));
  }, [e.reference, t]), y(
    () => {
      var x;
      (c === "initial" || c === "open") && (x = m.current) != null && x.innerHTML && (u.current = m.current.innerHTML);
    },
    // `props.children` is added to the deps, since it's ultimately the HTML of
    // the children that we're storing.
    [c, e.reference, e.children]
  ), !r)
    return !1;
  const h = {
    ...e.elementProps,
    style: {
      display: "flex",
      ...(g = e.elementProps) == null ? void 0 : g.style,
      zIndex: `calc(var(--bn-ui-base-z-index) + ${((p = (b = e.elementProps) == null ? void 0 : b.style) == null ? void 0 : p.zIndex) || 0})`,
      ...n,
      ...i
    },
    ...d()
  };
  return c === "close" ? /* @__PURE__ */ l(
    "div",
    {
      ref: f,
      ...h,
      dangerouslySetInnerHTML: { __html: u.current }
    }
  ) : /* @__PURE__ */ l("div", { ref: f, ...h, children: e.children });
}, Bt = (e) => {
  const { blockId: t, children: n, ...o } = e, r = C(), i = S(
    () => r.transact((c) => {
      if (!t)
        return;
      const s = Ge(t, c.doc);
      if (!s)
        return;
      const { node: a } = r.prosemirrorView.domAtPos(
        s.posBeforeNode + 1
      );
      if (a instanceof Element)
        return {
          element: a
        };
    }),
    [r, t]
  );
  return /* @__PURE__ */ l(U, { reference: i, ...o, children: t !== void 0 && n });
};
function T(e, t) {
  const o = ((t == null ? void 0 : t.editor) ?? C()).getExtension(e);
  if (!o)
    throw new Error("Extension not found", { cause: { plugin: e } });
  return o;
}
function _(e, t) {
  const { store: n } = T(e, t);
  if (!n)
    throw new Error("Store not found on plugin", { cause: { plugin: e } });
  return Jn(n, t == null ? void 0 : t.selector);
}
const so = (e) => {
  const t = C(), n = T(he), o = _(he), r = S(
    () => ({
      useFloatingOptions: {
        open: !!o,
        // Needed as hooks like `useDismiss` call `onOpenChange` to change the
        // open state.
        onOpenChange: (c, s, a) => {
          c || n.closeMenu(), a === "escape-key" && t.focus();
        },
        middleware: [j(10), Q()]
      },
      elementProps: {
        style: {
          zIndex: 90
        }
      },
      ...e.floatingUIOptions
    }),
    [o, t, n, e.floatingUIOptions]
  ), i = e.filePanel || _t;
  return /* @__PURE__ */ l(Bt, { blockId: o, ...r, children: o && /* @__PURE__ */ l(i, { blockId: o }) });
};
function uo(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var mo = function e(t, n) {
  if (t === n) return !0;
  if (t && n && typeof t == "object" && typeof n == "object") {
    if (t.constructor !== n.constructor) return !1;
    var o, r, i;
    if (Array.isArray(t)) {
      if (o = t.length, o != n.length) return !1;
      for (r = o; r-- !== 0; )
        if (!e(t[r], n[r])) return !1;
      return !0;
    }
    if (t instanceof Map && n instanceof Map) {
      if (t.size !== n.size) return !1;
      for (r of t.entries())
        if (!n.has(r[0])) return !1;
      for (r of t.entries())
        if (!e(r[1], n.get(r[0]))) return !1;
      return !0;
    }
    if (t instanceof Set && n instanceof Set) {
      if (t.size !== n.size) return !1;
      for (r of t.entries())
        if (!n.has(r[0])) return !1;
      return !0;
    }
    if (ArrayBuffer.isView(t) && ArrayBuffer.isView(n)) {
      if (o = t.length, o != n.length) return !1;
      for (r = o; r-- !== 0; )
        if (t[r] !== n[r]) return !1;
      return !0;
    }
    if (t.constructor === RegExp) return t.source === n.source && t.flags === n.flags;
    if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === n.valueOf();
    if (t.toString !== Object.prototype.toString) return t.toString() === n.toString();
    if (i = Object.keys(t), o = i.length, o !== Object.keys(n).length) return !1;
    for (r = o; r-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(n, i[r])) return !1;
    for (r = o; r-- !== 0; ) {
      var c = i[r];
      if (!(c === "_owner" && t.$$typeof) && !e(t[c], n[c]))
        return !1;
    }
    return !0;
  }
  return t !== t && n !== n;
};
const fo = /* @__PURE__ */ uo(mo);
var Ie = { exports: {} }, Me = {}, se = { exports: {} }, Te = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var nt;
function ho() {
  if (nt) return Te;
  nt = 1;
  var e = D;
  function t(m, f) {
    return m === f && (m !== 0 || 1 / m === 1 / f) || m !== m && f !== f;
  }
  var n = typeof Object.is == "function" ? Object.is : t, o = e.useState, r = e.useEffect, i = e.useLayoutEffect, c = e.useDebugValue;
  function s(m, f) {
    var h = f(), g = o({ inst: { value: h, getSnapshot: f } }), b = g[0].inst, p = g[1];
    return i(
      function() {
        b.value = h, b.getSnapshot = f, a(b) && p({ inst: b });
      },
      [m, h, f]
    ), r(
      function() {
        return a(b) && p({ inst: b }), m(function() {
          a(b) && p({ inst: b });
        });
      },
      [m]
    ), c(h), h;
  }
  function a(m) {
    var f = m.getSnapshot;
    m = m.value;
    try {
      var h = f();
      return !n(m, h);
    } catch {
      return !0;
    }
  }
  function d(m, f) {
    return f();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? d : s;
  return Te.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : u, Te;
}
var _e = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ot;
function go() {
  return ot || (ot = 1, process.env.NODE_ENV !== "production" && function() {
    function e(h, g) {
      return h === g && (h !== 0 || 1 / h === 1 / g) || h !== h && g !== g;
    }
    function t(h, g) {
      u || r.startTransition === void 0 || (u = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var b = g();
      if (!m) {
        var p = g();
        i(b, p) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), m = !0);
      }
      p = c({
        inst: { value: b, getSnapshot: g }
      });
      var x = p[0].inst, I = p[1];
      return a(
        function() {
          x.value = b, x.getSnapshot = g, n(x) && I({ inst: x });
        },
        [h, b, g]
      ), s(
        function() {
          return n(x) && I({ inst: x }), h(function() {
            n(x) && I({ inst: x });
          });
        },
        [h]
      ), d(b), b;
    }
    function n(h) {
      var g = h.getSnapshot;
      h = h.value;
      try {
        var b = g();
        return !i(h, b);
      } catch {
        return !0;
      }
    }
    function o(h, g) {
      return g();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var r = D, i = typeof Object.is == "function" ? Object.is : e, c = r.useState, s = r.useEffect, a = r.useLayoutEffect, d = r.useDebugValue, u = !1, m = !1, f = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? o : t;
    _e.useSyncExternalStore = r.useSyncExternalStore !== void 0 ? r.useSyncExternalStore : f, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), _e;
}
var rt;
function Et() {
  return rt || (rt = 1, process.env.NODE_ENV === "production" ? se.exports = ho() : se.exports = go()), se.exports;
}
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var it;
function bo() {
  if (it) return Me;
  it = 1;
  var e = D, t = Et();
  function n(d, u) {
    return d === u && (d !== 0 || 1 / d === 1 / u) || d !== d && u !== u;
  }
  var o = typeof Object.is == "function" ? Object.is : n, r = t.useSyncExternalStore, i = e.useRef, c = e.useEffect, s = e.useMemo, a = e.useDebugValue;
  return Me.useSyncExternalStoreWithSelector = function(d, u, m, f, h) {
    var g = i(null);
    if (g.current === null) {
      var b = { hasValue: !1, value: null };
      g.current = b;
    } else b = g.current;
    g = s(
      function() {
        function x(B) {
          if (!I) {
            if (I = !0, O = B, B = f(B), h !== void 0 && b.hasValue) {
              var P = b.value;
              if (h(P, B))
                return E = P;
            }
            return E = B;
          }
          if (P = E, o(O, B)) return P;
          var K = f(B);
          return h !== void 0 && h(P, K) ? (O = B, P) : (O = B, E = K);
        }
        var I = !1, O, E, $ = m === void 0 ? null : m;
        return [
          function() {
            return x(u());
          },
          $ === null ? void 0 : function() {
            return x($());
          }
        ];
      },
      [u, m, f, h]
    );
    var p = r(d, g[0], g[1]);
    return c(
      function() {
        b.hasValue = !0, b.value = p;
      },
      [p]
    ), a(p), p;
  }, Me;
}
var Be = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lt;
function po() {
  return lt || (lt = 1, process.env.NODE_ENV !== "production" && function() {
    function e(d, u) {
      return d === u && (d !== 0 || 1 / d === 1 / u) || d !== d && u !== u;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var t = D, n = Et(), o = typeof Object.is == "function" ? Object.is : e, r = n.useSyncExternalStore, i = t.useRef, c = t.useEffect, s = t.useMemo, a = t.useDebugValue;
    Be.useSyncExternalStoreWithSelector = function(d, u, m, f, h) {
      var g = i(null);
      if (g.current === null) {
        var b = { hasValue: !1, value: null };
        g.current = b;
      } else b = g.current;
      g = s(
        function() {
          function x(B) {
            if (!I) {
              if (I = !0, O = B, B = f(B), h !== void 0 && b.hasValue) {
                var P = b.value;
                if (h(P, B))
                  return E = P;
              }
              return E = B;
            }
            if (P = E, o(O, B))
              return P;
            var K = f(B);
            return h !== void 0 && h(P, K) ? (O = B, P) : (O = B, E = K);
          }
          var I = !1, O, E, $ = m === void 0 ? null : m;
          return [
            function() {
              return x(u());
            },
            $ === null ? void 0 : function() {
              return x($());
            }
          ];
        },
        [u, m, f, h]
      );
      var p = r(d, g[0], g[1]);
      return c(
        function() {
          b.hasValue = !0, b.value = p;
        },
        [p]
      ), a(p), p;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), Be;
}
process.env.NODE_ENV === "production" ? Ie.exports = bo() : Ie.exports = po();
var Co = Ie.exports;
const vo = typeof window < "u" ? cn : y;
class wo {
  constructor(t) {
    te(this, "transactionNumber", 0);
    te(this, "lastTransactionNumber", 0);
    te(this, "lastSnapshot");
    te(this, "editor");
    te(this, "subscribers", /* @__PURE__ */ new Set());
    this.editor = t, this.lastSnapshot = { editor: t, transactionNumber: 0 }, this.getSnapshot = this.getSnapshot.bind(this), this.getServerSnapshot = this.getServerSnapshot.bind(this), this.watch = this.watch.bind(this), this.subscribe = this.subscribe.bind(this);
  }
  /**
   * Get the current editor instance.
   */
  getSnapshot() {
    return this.transactionNumber === this.lastTransactionNumber ? this.lastSnapshot : (this.lastTransactionNumber = this.transactionNumber, this.lastSnapshot = {
      editor: this.editor,
      transactionNumber: this.transactionNumber
    }, this.lastSnapshot);
  }
  /**
   * Always disable the editor on the server-side.
   */
  getServerSnapshot() {
    return { editor: null, transactionNumber: 0 };
  }
  /**
   * Subscribe to the editor instance's changes.
   */
  subscribe(t) {
    return this.subscribers.add(t), () => {
      this.subscribers.delete(t);
    };
  }
  /**
   * Watch the editor instance for changes.
   */
  watch(t, n) {
    if (this.editor = t, this.editor) {
      const o = () => {
        this.transactionNumber += 1, this.subscribers.forEach((c) => c());
      }, r = this.editor._tiptapEditor, i = {
        all: "transaction",
        selection: "selectionUpdate",
        change: "update"
      };
      return r.on(i[n], o), () => {
        r.off(i[n], o);
      };
    }
  }
}
function R(e) {
  const t = q(), n = e.editor || (t == null ? void 0 : t.editor) || null, o = e.on || "all", [r] = M(() => new wo(n)), i = Co.useSyncExternalStoreWithSelector(
    r.subscribe,
    r.getSnapshot,
    r.getServerSnapshot,
    e.selector,
    e.equalityFn ?? fo
  );
  return vo(() => r.watch(n, o), [n, r, o]), an(i), i;
}
const Ue = (e) => {
  const { position: t, children: n, ...o } = e, { from: r, to: i } = t || {}, c = C(), s = S(() => {
    var a;
    if (!(r === void 0 || i === void 0))
      return {
        // Use first child as the editor DOM element may itself be scrollable.
        // For FloatingUI to auto-update the position during scrolling, the
        // `contextElement` must be a descendant of the scroll container.
        element: ((a = c.domElement) == null ? void 0 : a.firstElementChild) || void 0,
        getBoundingClientRect: () => Qn(c.prosemirrorView, r, i ?? r)
      };
  }, [c, r, i]);
  return /* @__PURE__ */ l(U, { reference: s, ...o, children: t !== void 0 && n });
};
var Lt = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, ct = D.createContext && /* @__PURE__ */ D.createContext(Lt), ko = ["attr", "size", "title"];
function Ho(e, t) {
  if (e == null) return {};
  var n = xo(e, t), o, r;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      o = i[r], !(t.indexOf(o) >= 0) && Object.prototype.propertyIsEnumerable.call(e, o) && (n[o] = e[o]);
  }
  return n;
}
function xo(e, t) {
  if (e == null) return {};
  var n = {};
  for (var o in e)
    if (Object.prototype.hasOwnProperty.call(e, o)) {
      if (t.indexOf(o) >= 0) continue;
      n[o] = e[o];
    }
  return n;
}
function ge() {
  return ge = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, ge.apply(this, arguments);
}
function at(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function be(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? at(Object(n), !0).forEach(function(o) {
      yo(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : at(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function yo(e, t, n) {
  return t = So(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function So(e) {
  var t = Vo(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Vo(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (typeof o != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Rt(e) {
  return e && e.map((t, n) => /* @__PURE__ */ D.createElement(t.tag, be({
    key: n
  }, t.attr), Rt(t.child)));
}
function w(e) {
  return (t) => /* @__PURE__ */ D.createElement(Mo, ge({
    attr: be({}, e.attr)
  }, t), Rt(e.child));
}
function Mo(e) {
  var t = (n) => {
    var {
      attr: o,
      size: r,
      title: i
    } = e, c = Ho(e, ko), s = r || n.size || "1em", a;
    return n.className && (a = n.className), e.className && (a = (a ? a + " " : "") + e.className), /* @__PURE__ */ D.createElement("svg", ge({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, n.attr, o, c, {
      className: a,
      style: be(be({
        color: e.color || n.color
      }, n.style), e.style),
      height: s,
      width: s,
      xmlns: "http://www.w3.org/2000/svg"
    }), i && /* @__PURE__ */ D.createElement("title", null, i), e.children);
  };
  return ct !== void 0 ? /* @__PURE__ */ D.createElement(ct.Consumer, null, (n) => t(n)) : t(Lt);
}
function To(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M8 7V11L2 6L8 1V5H13C17.4183 5 21 8.58172 21 13C21 17.4183 17.4183 21 13 21H4V19H13C16.3137 19 19 16.3137 19 13C19 9.68629 16.3137 7 13 7H8Z" }, child: [] }] })(e);
}
function Ot(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M7.29117 20.8242L2 22L3.17581 16.7088C2.42544 15.3056 2 13.7025 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C10.2975 22 8.6944 21.5746 7.29117 20.8242ZM7.58075 18.711L8.23428 19.0605C9.38248 19.6745 10.6655 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 13.3345 4.32549 14.6175 4.93949 15.7657L5.28896 16.4192L4.63416 19.3658L7.58075 18.711Z" }, child: [] }] })(e);
}
function _o(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M7.24264 17.9967H3V13.754L14.435 2.319C14.8256 1.92848 15.4587 1.92848 15.8492 2.319L18.6777 5.14743C19.0682 5.53795 19.0682 6.17112 18.6777 6.56164L7.24264 17.9967ZM3 19.9967H21V21.9967H3V19.9967Z" }, child: [] }] })(e);
}
function Bo(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M23 12L15.9289 19.0711L14.5147 17.6569L20.1716 12L14.5147 6.34317L15.9289 4.92896L23 12ZM3.82843 12L9.48528 17.6569L8.07107 19.0711L1 12L8.07107 4.92896L9.48528 6.34317L3.82843 12Z" }, child: [] }] })(e);
}
function je(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M3 8L9.00319 2H19.9978C20.5513 2 21 2.45531 21 2.9918V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5501 3 20.9932V8ZM10 4V9H5V20H19V4H10Z" }, child: [] }] })(e);
}
function Eo(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M3 4H21V6H3V4ZM5 19H19V21H5V19ZM3 14H21V16H3V14ZM5 9H19V11H5V9Z" }, child: [] }] })(e);
}
function Lo(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M3 4H21V6H3V4ZM3 19H21V21H3V19ZM3 14H21V16H3V14ZM3 9H21V11H3V9Z" }, child: [] }] })(e);
}
function Ro(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M3 4H21V6H3V4ZM3 19H17V21H3V19ZM3 14H21V16H3V14ZM3 9H17V11H3V9Z" }, child: [] }] })(e);
}
function Oo(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M3 4H21V6H3V4ZM7 19H21V21H7V19ZM3 14H21V16H3V14ZM7 9H21V11H7V9Z" }, child: [] }] })(e);
}
function Io(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M8 11H12.5C13.8807 11 15 9.88071 15 8.5C15 7.11929 13.8807 6 12.5 6H8V11ZM18 15.5C18 17.9853 15.9853 20 13.5 20H6V4H12.5C14.9853 4 17 6.01472 17 8.5C17 9.70431 16.5269 10.7981 15.7564 11.6058C17.0979 12.3847 18 13.837 18 15.5ZM8 13V18H13.5C14.8807 18 16 16.8807 16 15.5C16 14.1193 14.8807 13 13.5 13H8Z" }, child: [] }] })(e);
}
function Po(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M3.41436 5.99995L5.70726 3.70706L4.29304 2.29285L0.585938 5.99995L4.29304 9.70706L5.70726 8.29285L3.41436 5.99995ZM9.58594 5.99995L7.29304 3.70706L8.70726 2.29285L12.4144 5.99995L8.70726 9.70706L7.29304 8.29285L9.58594 5.99995ZM14.0002 2.99995H21.0002C21.5524 2.99995 22.0002 3.44767 22.0002 3.99995V20C22.0002 20.5522 21.5524 21 21.0002 21H3.00015C2.44787 21 2.00015 20.5522 2.00015 20V12H4.00015V19H20.0002V4.99995H14.0002V2.99995Z" }, child: [] }] })(e);
}
function st(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M5.55397 22H3.3999L10.9999 3H12.9999L20.5999 22H18.4458L16.0458 16H7.95397L5.55397 22ZM8.75397 14H15.2458L11.9999 5.88517L8.75397 14Z" }, child: [] }] })(e);
}
function pe(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M13 20H11V13H4V20H2V4H4V11H11V4H13V20ZM21.0005 8V20H19.0005L19 10.204L17 10.74V8.67L19.5005 8H21.0005Z" }, child: [] }] })(e);
}
function Ce(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M4 4V11H11V4H13V20H11V13H4V20H2V4H4ZM18.5 8C20.5711 8 22.25 9.67893 22.25 11.75C22.25 12.6074 21.9623 13.3976 21.4781 14.0292L21.3302 14.2102L18.0343 18H22V20H15L14.9993 18.444L19.8207 12.8981C20.0881 12.5908 20.25 12.1893 20.25 11.75C20.25 10.7835 19.4665 10 18.5 10C17.5818 10 16.8288 10.7071 16.7558 11.6065L16.75 11.75H14.75C14.75 9.67893 16.4289 8 18.5 8Z" }, child: [] }] })(e);
}
function ve(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M22 8L21.9984 10L19.4934 12.883C21.0823 13.3184 22.25 14.7728 22.25 16.5C22.25 18.5711 20.5711 20.25 18.5 20.25C16.674 20.25 15.1528 18.9449 14.8184 17.2166L16.7821 16.8352C16.9384 17.6413 17.6481 18.25 18.5 18.25C19.4665 18.25 20.25 17.4665 20.25 16.5C20.25 15.5335 19.4665 14.75 18.5 14.75C18.214 14.75 17.944 14.8186 17.7056 14.9403L16.3992 13.3932L19.3484 10H15V8H22ZM4 4V11H11V4H13V20H11V13H4V20H2V4H4Z" }, child: [] }] })(e);
}
function It(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M13 20H11V13H4V20H2V4H4V11H11V4H13V20ZM22 8V16H23.5V18H22V20H20V18H14.5V16.66L19.5 8H22ZM20 11.133L17.19 16H20V11.133Z" }, child: [] }] })(e);
}
function Pt(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M22 8V10H17.6769L17.2126 12.6358C17.5435 12.5472 17.8912 12.5 18.25 12.5C20.4591 12.5 22.25 14.2909 22.25 16.5C22.25 18.7091 20.4591 20.5 18.25 20.5C16.4233 20.5 14.8827 19.2756 14.4039 17.6027L16.3271 17.0519C16.5667 17.8881 17.3369 18.5 18.25 18.5C19.3546 18.5 20.25 17.6046 20.25 16.5C20.25 15.3954 19.3546 14.5 18.25 14.5C17.6194 14.5 17.057 14.7918 16.6904 15.2478L14.8803 14.3439L16 8H22ZM4 4V11H11V4H13V20H11V13H4V20H2V4H4Z" }, child: [] }] })(e);
}
function Nt(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M21.097 8L18.499 12.5C20.7091 12.5 22.5 14.2909 22.5 16.5C22.5 18.7091 20.7091 20.5 18.5 20.5C16.2909 20.5 14.5 18.7091 14.5 16.5C14.5 15.7636 14.699 15.0737 15.0461 14.4811L18.788 8H21.097ZM4 4V11H11V4H13V20H11V13H4V20H2V4H4ZM18.5 14.5C17.3954 14.5 16.5 15.3954 16.5 16.5C16.5 17.6046 17.3954 18.5 18.5 18.5C19.6046 18.5 20.5 17.6046 20.5 16.5C20.5 15.3954 19.6046 14.5 18.5 14.5Z" }, child: [] }] })(e);
}
function No(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M3 4H21V6H3V4ZM3 19H21V21H3V19ZM11 14H21V16H11V14ZM11 9H21V11H11V9ZM3 12.5L7 9V16L3 12.5Z" }, child: [] }] })(e);
}
function Ao(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M3 4H21V6H3V4ZM3 19H21V21H3V19ZM11 14H21V16H11V14ZM11 9H21V11H11V9ZM7 12.5L3 16V9L7 12.5Z" }, child: [] }] })(e);
}
function dt(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M8 5H11V19H8V21H16V19H13V5H16V3H8V5ZM2 7C1.44772 7 1 7.44772 1 8V16C1 16.5523 1.44772 17 2 17H8V15H3V9H8V7H2ZM16 9H21V15H16V17H22C22.5523 17 23 16.5523 23 16V8C23 7.44772 22.5523 7 22 7H16V9Z" }, child: [] }] })(e);
}
function Zo(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M15 20H7V18H9.92661L12.0425 6H9V4H17V6H14.0734L11.9575 18H15V20Z" }, child: [] }] })(e);
}
function Do(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M17 17H22V19H19V22H17V17ZM7 7H2V5H5V2H7V7ZM18.364 15.5355L16.9497 14.1213L18.364 12.7071C20.3166 10.7545 20.3166 7.58866 18.364 5.63604C16.4113 3.68342 13.2455 3.68342 11.2929 5.63604L9.87868 7.05025L8.46447 5.63604L9.87868 4.22183C12.6123 1.48816 17.0445 1.48816 19.7782 4.22183C22.5118 6.9555 22.5118 11.3877 19.7782 14.1213L18.364 15.5355ZM15.5355 18.364L14.1213 19.7782C11.3877 22.5118 6.9555 22.5118 4.22183 19.7782C1.48816 17.0445 1.48816 12.6123 4.22183 9.87868L5.63604 8.46447L7.05025 9.87868L5.63604 11.2929C3.68342 13.2455 3.68342 16.4113 5.63604 18.364C7.58866 20.3166 10.7545 20.3166 12.7071 18.364L14.1213 16.9497L15.5355 18.364ZM14.8284 7.75736L16.2426 9.17157L9.17157 16.2426L7.75736 14.8284L14.8284 7.75736Z" }, child: [] }] })(e);
}
function At(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M18.3638 15.5355L16.9496 14.1213L18.3638 12.7071C20.3164 10.7545 20.3164 7.58866 18.3638 5.63604C16.4112 3.68341 13.2453 3.68341 11.2927 5.63604L9.87849 7.05025L8.46428 5.63604L9.87849 4.22182C12.6122 1.48815 17.0443 1.48815 19.778 4.22182C22.5117 6.95549 22.5117 11.3876 19.778 14.1213L18.3638 15.5355ZM15.5353 18.364L14.1211 19.7782C11.3875 22.5118 6.95531 22.5118 4.22164 19.7782C1.48797 17.0445 1.48797 12.6123 4.22164 9.87868L5.63585 8.46446L7.05007 9.87868L5.63585 11.2929C3.68323 13.2455 3.68323 16.4113 5.63585 18.364C7.58847 20.3166 10.7543 20.3166 12.7069 18.364L14.1211 16.9497L15.5353 18.364ZM14.8282 7.75736L16.2425 9.17157L9.17139 16.2426L7.75717 14.8284L14.8282 7.75736Z" }, child: [] }] })(e);
}
function Zt(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M8.00008 6V9H5.00008V6H8.00008ZM3.00008 4V11H10.0001V4H3.00008ZM13.0001 4H21.0001V6H13.0001V4ZM13.0001 11H21.0001V13H13.0001V11ZM13.0001 18H21.0001V20H13.0001V18ZM10.7072 16.2071L9.29297 14.7929L6.00008 18.0858L4.20718 16.2929L2.79297 17.7071L6.00008 20.9142L10.7072 16.2071Z" }, child: [] }] })(e);
}
function Dt(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M8 4H21V6H8V4ZM5 3V6H6V7H3V6H4V4H3V3H5ZM3 14V11.5H5V11H3V10H6V12.5H4V13H6V14H3ZM5 19.5H3V18.5H5V18H3V17H6V21H3V20H5V19.5ZM8 11H21V13H8V11ZM8 18H21V20H8V18Z" }, child: [] }] })(e);
}
function Ft(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M8 4H21V6H8V4ZM4.5 6.5C3.67157 6.5 3 5.82843 3 5C3 4.17157 3.67157 3.5 4.5 3.5C5.32843 3.5 6 4.17157 6 5C6 5.82843 5.32843 6.5 4.5 6.5ZM4.5 13.5C3.67157 13.5 3 12.8284 3 12C3 11.1716 3.67157 10.5 4.5 10.5C5.32843 10.5 6 11.1716 6 12C6 12.8284 5.32843 13.5 4.5 13.5ZM4.5 20.4C3.67157 20.4 3 19.7284 3 18.9C3 18.0716 3.67157 17.4 4.5 17.4C5.32843 17.4 6 18.0716 6 18.9C6 19.7284 5.32843 20.4 4.5 20.4ZM8 11H21V13H8V11ZM8 18H21V20H8V18Z" }, child: [] }] })(e);
}
function Fo(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M20 3C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20ZM11 5H5V10.999H7V9L10 12L7 15V13H5V19H11V17H13V19H19V13H17V15L14 12L17 9V10.999H19V5H13V7H11V5ZM13 13V15H11V13H13ZM13 9V11H11V9H13Z" }, child: [] }] })(e);
}
function Go(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M21 20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V20ZM19 11V5H13.001V7H15L12 10L9 7H11V5H5V11H7V13H5V19H11V17H9L12 14L15 17H13.001V19H19V13H17V11H19ZM11 13H9V11H11V13ZM15 13H13V11H15V13Z" }, child: [] }] })(e);
}
function Gt(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M21 4H3V6H21V4ZM21 11H8V13H21V11ZM21 18H8V20H21V18ZM5 11H3V20H5V11Z" }, child: [] }] })(e);
}
function zo(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M17.1538 14C17.3846 14.5161 17.5 15.0893 17.5 15.7196C17.5 17.0625 16.9762 18.1116 15.9286 18.867C14.8809 19.6223 13.4335 20 11.5862 20C9.94674 20 8.32335 19.6185 6.71592 18.8555V16.6009C8.23538 17.4783 9.7908 17.917 11.3822 17.917C13.9333 17.917 15.2128 17.1846 15.2208 15.7196C15.2208 15.0939 15.0049 14.5598 14.5731 14.1173C14.5339 14.0772 14.4939 14.0381 14.4531 14H3V12H21V14H17.1538ZM13.076 11H7.62908C7.4566 10.8433 7.29616 10.6692 7.14776 10.4778C6.71592 9.92084 6.5 9.24559 6.5 8.45207C6.5 7.21602 6.96583 6.165 7.89749 5.299C8.82916 4.43299 10.2706 4 12.2219 4C13.6934 4 15.1009 4.32808 16.4444 4.98426V7.13591C15.2448 6.44921 13.9293 6.10587 12.4978 6.10587C10.0187 6.10587 8.77917 6.88793 8.77917 8.45207C8.77917 8.87172 8.99709 9.23796 9.43293 9.55079C9.86878 9.86362 10.4066 10.1135 11.0463 10.3004C11.6665 10.4816 12.3431 10.7148 13.076 11H13.076Z" }, child: [] }] })(e);
}
function Uo(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M13 10V14H19V10H13ZM11 10H5V14H11V10ZM13 19H19V16H13V19ZM11 19V16H5V19H11ZM13 5V8H19V5H13ZM11 5H5V8H11V5ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3Z" }, child: [] }] })(e);
}
function $e(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M13 6V21H11V6H5V4H19V6H13Z" }, child: [] }] })(e);
}
function jo(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M8 3V12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12V3H18V12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12V3H8ZM4 20H20V22H4V20Z" }, child: [] }] })(e);
}
function $o(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M2 3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934ZM8 5V19H16V5H8ZM4 5V7H6V5H4ZM18 5V7H20V5H18ZM4 9V11H6V9H4ZM18 9V11H20V9H18ZM4 13V15H6V13H4ZM18 13V15H20V13H18ZM4 17V19H6V17H4ZM18 17V19H20V17H18Z" }, child: [] }] })(e);
}
function zt(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M5 11.1005L7 9.1005L12.5 14.6005L16 11.1005L19 14.1005V5H5V11.1005ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM15.5 10C14.6716 10 14 9.32843 14 8.5C14 7.67157 14.6716 7 15.5 7C16.3284 7 17 7.67157 17 8.5C17 9.32843 16.3284 10 15.5 10Z" }, child: [] }] })(e);
}
function Wo(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M21 15V18H24V20H21V23H19V20H16V18H19V15H21ZM21.0082 3C21.556 3 22 3.44495 22 3.9934L22.0007 13.3417C21.3749 13.1204 20.7015 13 20 13V5H4L4.001 19L13.2929 9.70715C13.6528 9.34604 14.22 9.31823 14.6123 9.62322L14.7065 9.70772L18.2521 13.2586C15.791 14.0069 14 16.2943 14 19C14 19.7015 14.1204 20.3749 14.3417 21.0007L2.9918 21C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082ZM8 7C9.10457 7 10 7.89543 10 9C10 10.1046 9.10457 11 8 11C6.89543 11 6 10.1046 6 9C6 7.89543 6.89543 7 8 7Z" }, child: [] }] })(e);
}
function qo(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M20 3C20.5523 3 21 3.44772 21 4V5.757L19 7.757V5H5V13.1L9 9.1005L13.328 13.429L12.0012 14.7562L11.995 18.995L16.2414 19.0012L17.571 17.671L18.8995 19H19V16.242L21 14.242V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20ZM21.7782 7.80761L23.1924 9.22183L15.4142 17L13.9979 16.9979L14 15.5858L21.7782 7.80761ZM15.5 7C16.3284 7 17 7.67157 17 8.5C17 9.32843 16.3284 10 15.5 10C14.6716 10 14 9.32843 14 8.5C14 7.67157 14.6716 7 15.5 7Z" }, child: [] }] })(e);
}
function Ut(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M22 18V20H2V18H22ZM2 3.5L10 8.5L2 13.5V3.5ZM22 11V13H12V11H22ZM22 4V6H12V4H22Z" }, child: [] }] })(e);
}
function Ko(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M3 3.9934C3 3.44476 3.44495 3 3.9934 3H20.0066C20.5552 3 21 3.44495 21 3.9934V20.0066C21 20.5552 20.5551 21 20.0066 21H3.9934C3.44476 21 3 20.5551 3 20.0066V3.9934ZM10.6219 8.41459C10.5562 8.37078 10.479 8.34741 10.4 8.34741C10.1791 8.34741 10 8.52649 10 8.74741V15.2526C10 15.3316 10.0234 15.4088 10.0672 15.4745C10.1897 15.6583 10.4381 15.708 10.6219 15.5854L15.5008 12.3328C15.5447 12.3035 15.5824 12.2658 15.6117 12.2219C15.7343 12.0381 15.6846 11.7897 15.5008 11.6672L10.6219 8.41459Z" }, child: [] }] })(e);
}
function jt(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M2 16.0001H5.88889L11.1834 20.3319C11.2727 20.405 11.3846 20.4449 11.5 20.4449C11.7761 20.4449 12 20.2211 12 19.9449V4.05519C12 3.93977 11.9601 3.8279 11.887 3.73857C11.7121 3.52485 11.3971 3.49335 11.1834 3.66821L5.88889 8.00007H2C1.44772 8.00007 1 8.44778 1 9.00007V15.0001C1 15.5524 1.44772 16.0001 2 16.0001ZM23 12C23 15.292 21.5539 18.2463 19.2622 20.2622L17.8445 18.8444C19.7758 17.1937 21 14.7398 21 12C21 9.26016 19.7758 6.80629 17.8445 5.15557L19.2622 3.73779C21.5539 5.75368 23 8.70795 23 12ZM18 12C18 10.0883 17.106 8.38548 15.7133 7.28673L14.2842 8.71584C15.3213 9.43855 16 10.64 16 12C16 13.36 15.3213 14.5614 14.2842 15.2841L15.7133 16.7132C17.106 15.6145 18 13.9116 18 12Z" }, child: [] }] })(e);
}
function Xo(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M11 11V5H13V11H19V13H13V19H11V13H5V11H11Z" }, child: [] }] })(e);
}
function Yo(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M9.9997 15.1709L19.1921 5.97852L20.6063 7.39273L9.9997 17.9993L3.63574 11.6354L5.04996 10.2212L9.9997 15.1709Z" }, child: [] }] })(e);
}
function Jo(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM9 4V6H15V4H9Z" }, child: [] }] })(e);
}
function Qo(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM9 11V17H11V11H9ZM13 11V17H15V11H13ZM9 4V6H15V4H9Z" }, child: [] }] })(e);
}
function er(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M4 19H20V12H22V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V12H4V19ZM14 9H19L12 16L5 9H10V3H14V9Z" }, child: [] }] })(e);
}
function tr(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M10 6V8H5V19H16V14H18V20C18 20.5523 17.5523 21 17 21H4C3.44772 21 3 20.5523 3 20V7C3 6.44772 3.44772 6 4 6H10ZM21 3V12L17.206 8.207L11.2071 14.2071L9.79289 12.7929L15.792 6.793L12 3H21Z" }, child: [] }] })(e);
}
function nr(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M5 10C3.9 10 3 10.9 3 12C3 13.1 3.9 14 5 14C6.1 14 7 13.1 7 12C7 10.9 6.1 10 5 10ZM19 10C17.9 10 17 10.9 17 12C17 13.1 17.9 14 19 14C20.1 14 21 13.1 21 12C21 10.9 20.1 10 19 10ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z" }, child: [] }] })(e);
}
function or(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M5 11V13H19V11H5Z" }, child: [] }] })(e);
}
function rr(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM8 13C8 15.2091 9.79086 17 12 17C14.2091 17 16 15.2091 16 13H8ZM8 11C8.82843 11 9.5 10.3284 9.5 9.5C9.5 8.67157 8.82843 8 8 8C7.17157 8 6.5 8.67157 6.5 9.5C6.5 10.3284 7.17157 11 8 11ZM16 11C16.8284 11 17.5 10.3284 17.5 9.5C17.5 8.67157 16.8284 8 16 8C15.1716 8 14.5 8.67157 14.5 9.5C14.5 10.3284 15.1716 11 16 11Z" }, child: [] }] })(e);
}
function ut(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM8 13H16C16 15.2091 14.2091 17 12 17C9.79086 17 8 15.2091 8 13ZM8 11C7.17157 11 6.5 10.3284 6.5 9.5C6.5 8.67157 7.17157 8 8 8C8.82843 8 9.5 8.67157 9.5 9.5C9.5 10.3284 8.82843 11 8 11ZM16 11C15.1716 11 14.5 10.3284 14.5 9.5C14.5 8.67157 15.1716 8 16 8C16.8284 8 17.5 8.67157 17.5 9.5C17.5 10.3284 16.8284 11 16 11Z" }, child: [] }] })(e);
}
const ir = {
  bold: Io,
  italic: Zo,
  underline: jo,
  strike: zo,
  code: Bo
};
function lr(e, t) {
  return e in t.schema.styleSchema && t.schema.styleSchema[e].type === e && t.schema.styleSchema[e].propSchema === "boolean";
}
const de = (e) => {
  const t = V(), n = v(), o = C(), r = R({
    editor: o,
    selector: ({ editor: s }) => {
      var a;
      if (
        // The editor is read-only.
        !(!s.isEditable || // The style is not in the schema.
        !lr(e.basicTextStyle, s) || // None of the selected blocks have inline content
        !(((a = s.getSelection()) == null ? void 0 : a.blocks) || [
          s.getTextCursorPosition().block
        ]).find((d) => d.content !== void 0))
      )
        return e.basicTextStyle in s.getActiveStyles() ? { active: !0 } : { active: !1 };
    }
  }), i = k(
    (s) => {
      o.focus(), o.toggleStyles({ [s]: !0 });
    },
    [o, e]
  );
  if (r === void 0)
    return null;
  const c = ir[e.basicTextStyle];
  return /* @__PURE__ */ l(
    n.FormattingToolbar.Button,
    {
      className: "bn-button",
      "data-test": e.basicTextStyle,
      onClick: () => i(e.basicTextStyle),
      isSelected: r.active,
      label: t.formatting_toolbar[e.basicTextStyle].tooltip,
      mainTooltip: t.formatting_toolbar[e.basicTextStyle].tooltip,
      secondaryTooltip: He(
        t.formatting_toolbar[e.basicTextStyle].secondary_tooltip,
        t.generic.ctrl_shortcut
      ),
      icon: /* @__PURE__ */ l(c, {})
    }
  );
}, Pe = (e) => {
  const t = e.textColor || "default", n = e.backgroundColor || "default", o = e.size || 16, r = S(
    () => ({
      pointerEvents: "none",
      fontSize: (o * 0.75).toString() + "px",
      height: o.toString() + "px",
      lineHeight: o.toString() + "px",
      textAlign: "center",
      width: o.toString() + "px"
    }),
    [o]
  );
  return /* @__PURE__ */ l(
    "div",
    {
      className: "bn-color-icon",
      "data-background-color": n,
      "data-text-color": t,
      style: r,
      children: "A"
    }
  );
}, mt = [
  "default",
  "gray",
  "brown",
  "red",
  "orange",
  "yellow",
  "green",
  "blue",
  "purple",
  "pink"
], xe = (e) => {
  const t = v(), n = V();
  return /* @__PURE__ */ H(N, { children: [
    /* @__PURE__ */ l(() => e.text ? /* @__PURE__ */ H(N, { children: [
      /* @__PURE__ */ l(t.Generic.Menu.Label, { children: n.color_picker.text_title }),
      mt.map((i) => /* @__PURE__ */ l(
        t.Generic.Menu.Item,
        {
          onClick: () => {
            e.onClick && e.onClick(), e.text.setColor(i);
          },
          "data-test": "text-color-" + i,
          icon: /* @__PURE__ */ l(Pe, { textColor: i, size: e.iconSize }),
          checked: e.text.color === i,
          children: n.color_picker.colors[i]
        },
        "text-color-" + i
      ))
    ] }) : null, {}),
    /* @__PURE__ */ l(() => e.background ? /* @__PURE__ */ H(N, { children: [
      /* @__PURE__ */ l(t.Generic.Menu.Label, { children: n.color_picker.background_title }),
      mt.map((i) => /* @__PURE__ */ l(
        t.Generic.Menu.Item,
        {
          onClick: () => {
            e.onClick && e.onClick(), e.background.setColor(i);
          },
          "data-test": "background-color-" + i,
          icon: /* @__PURE__ */ l(Pe, { backgroundColor: i, size: e.iconSize }),
          checked: e.background.color === i,
          children: n.color_picker.colors[i]
        },
        "background-color-" + i
      ))
    ] }) : null, {})
  ] });
};
function ue(e, t) {
  return `${e}Color` in t.schema.styleSchema && t.schema.styleSchema[`${e}Color`].type === `${e}Color` && t.schema.styleSchema[`${e}Color`].propSchema === "string";
}
const cr = () => {
  const e = v(), t = V(), n = C(), o = ue("text", n), r = ue("background", n), i = R({
    editor: n,
    selector: ({ editor: a }) => {
      var m;
      if (
        // The editor is read-only.
        !a.isEditable || // None of the selected blocks have inline content
        !(((m = a.getSelection()) == null ? void 0 : m.blocks) || [
          a.getTextCursorPosition().block
        ]).find((f) => f.content !== void 0)
      )
        return;
      const d = ue("text", a), u = ue("background", a);
      if (!(!d && !u))
        return {
          textColor: d ? a.getActiveStyles().textColor || "default" : void 0,
          backgroundColor: u ? a.getActiveStyles().backgroundColor || "default" : void 0
        };
    }
  }), c = k(
    (a) => {
      if (!o)
        throw Error(
          "Tried to set text color, but style does not exist in editor schema."
        );
      a === "default" ? n.removeStyles({ textColor: a }) : n.addStyles({ textColor: a }), setTimeout(() => {
        n.focus();
      });
    },
    [n, o]
  ), s = k(
    (a) => {
      if (!r)
        throw Error(
          "Tried to set background color, but style does not exist in editor schema."
        );
      a === "default" ? n.removeStyles({ backgroundColor: a }) : n.addStyles({ backgroundColor: a }), setTimeout(() => {
        n.focus();
      });
    },
    [r, n]
  );
  return i === void 0 ? null : /* @__PURE__ */ H(e.Generic.Menu.Root, { children: [
    /* @__PURE__ */ l(e.Generic.Menu.Trigger, { children: /* @__PURE__ */ l(
      e.FormattingToolbar.Button,
      {
        className: "bn-button",
        "data-test": "colors",
        label: t.formatting_toolbar.colors.tooltip,
        mainTooltip: t.formatting_toolbar.colors.tooltip,
        icon: /* @__PURE__ */ l(
          Pe,
          {
            textColor: i.textColor,
            backgroundColor: i.backgroundColor,
            size: 20
          }
        )
      }
    ) }),
    /* @__PURE__ */ l(
      e.Generic.Menu.Dropdown,
      {
        className: "bn-menu-dropdown bn-color-picker-dropdown",
        children: /* @__PURE__ */ l(
          xe,
          {
            text: i.textColor ? {
              color: i.textColor,
              setColor: c
            } : void 0,
            background: i.backgroundColor ? {
              color: i.backgroundColor,
              setColor: s
            } : void 0
          }
        )
      }
    )
  ] });
}, ft = (e) => {
  for (const t of fn)
    if (e.startsWith(t))
      return e;
  return `${hn}://${e}`;
}, $t = (e) => {
  const t = v(), n = V(), { editLink: o } = T(ke), { url: r, text: i, showTextField: c } = e, [s, a] = M(r), [d, u] = M(i);
  y(() => {
    a(r), u(i);
  }, [i, r]);
  const m = k(
    (b) => {
      var p, x;
      b.key === "Enter" && (b.preventDefault(), o(ft(s), d, e.range.from), (p = e.setToolbarOpen) == null || p.call(e, !1), (x = e.setToolbarFrozen) == null || x.call(e, !1));
    },
    [o, s, d, e]
  ), f = k(
    (b) => a(b.currentTarget.value),
    []
  ), h = k(
    (b) => u(b.currentTarget.value),
    []
  ), g = k(() => {
    var b, p;
    o(ft(s), d, e.range.from), (b = e.setToolbarOpen) == null || b.call(e, !1), (p = e.setToolbarFrozen) == null || p.call(e, !1);
  }, [o, s, d, e]);
  return /* @__PURE__ */ H(t.Generic.Form.Root, { children: [
    /* @__PURE__ */ l(
      t.Generic.Form.TextInput,
      {
        className: "bn-text-input",
        name: "url",
        icon: /* @__PURE__ */ l(At, {}),
        autoFocus: !0,
        placeholder: n.link_toolbar.form.url_placeholder,
        value: s,
        onKeyDown: m,
        onChange: f,
        onSubmit: g
      }
    ),
    c !== !1 && /* @__PURE__ */ l(
      t.Generic.Form.TextInput,
      {
        className: "bn-text-input",
        name: "title",
        icon: /* @__PURE__ */ l($e, {}),
        placeholder: n.link_toolbar.form.title_placeholder,
        value: d,
        onKeyDown: m,
        onChange: h,
        onSubmit: g
      }
    )
  ] });
};
function ar(e) {
  return "link" in e.schema.inlineContentSchema && e.schema.inlineContentSchema.link === "link";
}
const sr = () => {
  const e = C(), t = v(), n = V(), o = T(ne), { showSelection: r } = T(gn), [i, c] = M(!1);
  y(() => {
    r(i);
  }, [i, r]);
  const s = R({
    editor: e,
    selector: ({ editor: a }) => {
      var d;
      if (
        // The editor is read-only.
        !(!a.isEditable || // Links are not in the schema.
        !ar(a) || // Table cells are selected.
        Vn(a.prosemirrorState.selection) || // None of the selected blocks have inline content
        !(((d = a.getSelection()) == null ? void 0 : d.blocks) || [
          a.getTextCursorPosition().block
        ]).find((u) => u.content !== void 0))
      )
        return {
          url: a.getSelectedLinkUrl(),
          text: a.getSelectedText(),
          range: {
            from: a.prosemirrorState.selection.from,
            to: a.prosemirrorState.selection.to
          }
        };
    }
  });
  return y(() => {
    const a = (d) => {
      (d.ctrlKey || d.metaKey) && d.key === "k" && (c(!0), d.preventDefault());
    };
    return e.prosemirrorView.dom.addEventListener("keydown", a), () => {
      e.prosemirrorView.dom.removeEventListener("keydown", a);
    };
  }, [e.prosemirrorView, e.headless]), s === void 0 ? null : /* @__PURE__ */ H(t.Generic.Popover.Root, { open: i, children: [
    /* @__PURE__ */ l(t.Generic.Popover.Trigger, { children: /* @__PURE__ */ l(
      t.FormattingToolbar.Button,
      {
        className: "bn-button",
        "data-test": "createLink",
        label: n.formatting_toolbar.link.tooltip,
        mainTooltip: n.formatting_toolbar.link.tooltip,
        secondaryTooltip: He(
          n.formatting_toolbar.link.secondary_tooltip,
          n.generic.ctrl_shortcut
        ),
        icon: /* @__PURE__ */ l(At, {}),
        onClick: () => c(!0)
      }
    ) }),
    /* @__PURE__ */ l(
      t.Generic.Popover.Content,
      {
        className: "bn-popover-content bn-form-popover",
        variant: "form-popover",
        children: /* @__PURE__ */ l(
          $t,
          {
            url: s.url || "",
            text: s.text,
            range: s.range,
            showTextField: !1,
            setToolbarOpen: (a) => o.store.setState(a)
          }
        )
      }
    )
  ] });
}, dr = () => {
  const e = V(), t = v(), n = C(), o = R({
    editor: n,
    selector: ({ editor: a }) => {
      var m;
      if (!a.isEditable)
        return;
      const d = ((m = a.getSelection()) == null ? void 0 : m.blocks) || [
        a.getTextCursorPosition().block
      ];
      if (d.length !== 1)
        return;
      const u = d[0];
      if (A(u, a, u.type, {
        url: "string",
        caption: "string"
      }))
        return u;
    }
  }), [r, i] = M();
  y(() => {
    o !== void 0 && i(o.props.caption);
  }, [o]);
  const c = k(
    (a) => i(a.currentTarget.value),
    []
  ), s = k(
    (a) => {
      o !== void 0 && J(n, o.type, {
        caption: "string"
      }) && a.key === "Enter" && (a.preventDefault(), n.updateBlock(o.id, {
        props: {
          caption: r
        }
      }));
    },
    [o, r, n]
  );
  return o === void 0 ? null : /* @__PURE__ */ H(t.Generic.Popover.Root, { children: [
    /* @__PURE__ */ l(t.Generic.Popover.Trigger, { children: /* @__PURE__ */ l(
      t.FormattingToolbar.Button,
      {
        className: "bn-button",
        label: e.formatting_toolbar.file_caption.tooltip,
        mainTooltip: e.formatting_toolbar.file_caption.tooltip,
        icon: /* @__PURE__ */ l(dt, {})
      }
    ) }),
    /* @__PURE__ */ l(
      t.Generic.Popover.Content,
      {
        className: "bn-popover-content bn-form-popover",
        variant: "form-popover",
        children: /* @__PURE__ */ l(t.Generic.Form.Root, { children: /* @__PURE__ */ l(
          t.Generic.Form.TextInput,
          {
            name: "file-caption",
            icon: /* @__PURE__ */ l(dt, {}),
            value: r || "",
            autoFocus: !0,
            placeholder: e.formatting_toolbar.file_caption.input_placeholder,
            onKeyDown: s,
            onChange: c
          }
        ) })
      }
    )
  ] });
}, ur = () => {
  const e = V(), t = v(), n = C(), o = R({
    editor: n,
    selector: ({ editor: i }) => {
      var a;
      if (!i.isEditable)
        return;
      const c = ((a = i.getSelection()) == null ? void 0 : a.blocks) || [
        i.getTextCursorPosition().block
      ];
      if (c.length !== 1)
        return;
      const s = c[0];
      if (A(s, i, s.type, {
        url: "string"
      }))
        return s;
    }
  }), r = k(() => {
    o !== void 0 && (n.focus(), n.removeBlocks([o.id]));
  }, [o, n]);
  return o === void 0 ? null : /* @__PURE__ */ l(
    t.FormattingToolbar.Button,
    {
      className: "bn-button",
      label: e.formatting_toolbar.file_delete.tooltip[o.type] || e.formatting_toolbar.file_delete.tooltip.file,
      mainTooltip: e.formatting_toolbar.file_delete.tooltip[o.type] || e.formatting_toolbar.file_delete.tooltip.file,
      icon: /* @__PURE__ */ l(Jo, {}),
      onClick: r
    }
  );
}, mr = () => {
  const e = V(), t = v(), n = C(), o = R({
    editor: n,
    selector: ({ editor: a }) => {
      var m;
      if (!a.isEditable)
        return;
      const d = ((m = a.getSelection()) == null ? void 0 : m.blocks) || [
        a.getTextCursorPosition().block
      ];
      if (d.length !== 1)
        return;
      const u = d[0];
      if (A(u, a, u.type, {
        url: "string",
        name: "string"
      }))
        return u;
    }
  }), [r, i] = M();
  y(() => {
    o !== void 0 && i(o.props.name);
  }, [o]);
  const c = k(
    (a) => i(a.currentTarget.value),
    []
  ), s = k(
    (a) => {
      o !== void 0 && J(n, o.type, {
        name: "string"
      }) && a.key === "Enter" && (a.preventDefault(), n.updateBlock(o.id, {
        props: {
          name: r
        }
      }));
    },
    [o, r, n]
  );
  return o === void 0 ? null : /* @__PURE__ */ H(t.Generic.Popover.Root, { children: [
    /* @__PURE__ */ l(t.Generic.Popover.Trigger, { children: /* @__PURE__ */ l(
      t.FormattingToolbar.Button,
      {
        className: "bn-button",
        label: e.formatting_toolbar.file_rename.tooltip[o.type] || e.formatting_toolbar.file_rename.tooltip.file,
        mainTooltip: e.formatting_toolbar.file_rename.tooltip[o.type] || e.formatting_toolbar.file_rename.tooltip.file,
        icon: /* @__PURE__ */ l(st, {})
      }
    ) }),
    /* @__PURE__ */ l(
      t.Generic.Popover.Content,
      {
        className: "bn-popover-content bn-form-popover",
        variant: "form-popover",
        children: /* @__PURE__ */ l(t.Generic.Form.Root, { children: /* @__PURE__ */ l(
          t.Generic.Form.TextInput,
          {
            name: "file-name",
            icon: /* @__PURE__ */ l(st, {}),
            value: r || "",
            autoFocus: !0,
            placeholder: e.formatting_toolbar.file_rename.input_placeholder[o.type] || e.formatting_toolbar.file_rename.input_placeholder.file,
            onKeyDown: s,
            onChange: c
          }
        ) })
      }
    )
  ] });
}, fr = () => {
  const e = V(), t = v(), n = C(), o = R({
    editor: n,
    selector: ({ editor: r }) => {
      var s;
      if (!r.isEditable)
        return;
      const i = ((s = r.getSelection()) == null ? void 0 : s.blocks) || [
        r.getTextCursorPosition().block
      ];
      if (i.length !== 1)
        return;
      const c = i[0];
      if (A(c, r, c.type, {
        url: "string"
      }))
        return c;
    }
  });
  return o === void 0 ? null : /* @__PURE__ */ H(t.Generic.Popover.Root, { position: "bottom", children: [
    /* @__PURE__ */ l(t.Generic.Popover.Trigger, { children: /* @__PURE__ */ l(
      t.FormattingToolbar.Button,
      {
        className: "bn-button",
        mainTooltip: e.formatting_toolbar.file_replace.tooltip[o.type] || e.formatting_toolbar.file_replace.tooltip.file,
        label: e.formatting_toolbar.file_replace.tooltip[o.type] || e.formatting_toolbar.file_replace.tooltip.file,
        icon: /* @__PURE__ */ l(qo, {})
      }
    ) }),
    /* @__PURE__ */ l(
      t.Generic.Popover.Content,
      {
        className: "bn-popover-content bn-panel-popover",
        variant: "panel-popover",
        children: /* @__PURE__ */ l(_t, { blockId: o.id })
      }
    )
  ] });
}, hr = () => {
  const e = V(), t = v(), n = C(), o = R({
    editor: n,
    selector: ({ editor: i }) => {
      var c;
      if (
        // The editor is read-only.
        !(!i.isEditable || // None of the selected blocks have inline content
        !(((c = i.getSelection()) == null ? void 0 : c.blocks) || [
          i.getTextCursorPosition().block
        ]).find((s) => s.content !== void 0))
      )
        return {
          canNestBlock: i.canNestBlock()
        };
    }
  }), r = k(() => {
    o !== void 0 && o.canNestBlock && (n.focus(), n.nestBlock());
  }, [n, o]);
  return o === void 0 ? null : /* @__PURE__ */ l(
    t.FormattingToolbar.Button,
    {
      className: "bn-button",
      "data-test": "nestBlock",
      onClick: r,
      isDisabled: !o.canNestBlock,
      label: e.formatting_toolbar.nest.tooltip,
      mainTooltip: e.formatting_toolbar.nest.tooltip,
      secondaryTooltip: He(
        e.formatting_toolbar.nest.secondary_tooltip,
        e.generic.ctrl_shortcut
      ),
      icon: /* @__PURE__ */ l(Ao, {})
    }
  );
}, gr = () => {
  const e = V(), t = v(), n = C(), o = R({
    editor: n,
    selector: ({ editor: i }) => {
      var c;
      if (
        // The editor is read-only.
        !(!i.isEditable || // None of the selected blocks have inline content
        !(((c = i.getSelection()) == null ? void 0 : c.blocks) || [
          i.getTextCursorPosition().block
        ]).find((s) => s.content !== void 0))
      )
        return {
          canUnnestBlock: i.canUnnestBlock()
        };
    }
  }), r = k(() => {
    o !== void 0 && o.canUnnestBlock && (n.focus(), n.unnestBlock());
  }, [n, o]);
  return o === void 0 ? null : /* @__PURE__ */ l(
    t.FormattingToolbar.Button,
    {
      className: "bn-button",
      "data-test": "unnestBlock",
      onClick: r,
      isDisabled: !o.canUnnestBlock,
      label: e.formatting_toolbar.unnest.tooltip,
      mainTooltip: e.formatting_toolbar.unnest.tooltip,
      secondaryTooltip: He(
        e.formatting_toolbar.unnest.secondary_tooltip,
        e.generic.ctrl_shortcut
      ),
      icon: /* @__PURE__ */ l(No, {})
    }
  );
}, br = (e) => [
  {
    name: e.slash_menu.paragraph.title,
    type: "paragraph",
    icon: $e
  },
  {
    name: e.slash_menu.heading.title,
    type: "heading",
    props: { level: 1, isToggleable: !1 },
    icon: pe
  },
  {
    name: e.slash_menu.heading_2.title,
    type: "heading",
    props: { level: 2, isToggleable: !1 },
    icon: Ce
  },
  {
    name: e.slash_menu.heading_3.title,
    type: "heading",
    props: { level: 3, isToggleable: !1 },
    icon: ve
  },
  {
    name: e.slash_menu.heading_4.title,
    type: "heading",
    props: { level: 4, isToggleable: !1 },
    icon: It
  },
  {
    name: e.slash_menu.heading_5.title,
    type: "heading",
    props: { level: 5, isToggleable: !1 },
    icon: Pt
  },
  {
    name: e.slash_menu.heading_6.title,
    type: "heading",
    props: { level: 6, isToggleable: !1 },
    icon: Nt
  },
  {
    name: e.slash_menu.toggle_heading.title,
    type: "heading",
    props: { level: 1, isToggleable: !0 },
    icon: pe
  },
  {
    name: e.slash_menu.toggle_heading_2.title,
    type: "heading",
    props: { level: 2, isToggleable: !0 },
    icon: Ce
  },
  {
    name: e.slash_menu.toggle_heading_3.title,
    type: "heading",
    props: { level: 3, isToggleable: !0 },
    icon: ve
  },
  {
    name: e.slash_menu.quote.title,
    type: "quote",
    icon: Gt
  },
  {
    name: e.slash_menu.toggle_list.title,
    type: "toggleListItem",
    icon: Ut
  },
  {
    name: e.slash_menu.bullet_list.title,
    type: "bulletListItem",
    icon: Ft
  },
  {
    name: e.slash_menu.numbered_list.title,
    type: "numberedListItem",
    icon: Dt
  },
  {
    name: e.slash_menu.check_list.title,
    type: "checkListItem",
    icon: Zt
  }
], pr = (e) => {
  const t = v(), n = C(), o = R({
    editor: n,
    selector: ({ editor: a }) => {
      var d;
      return ((d = a.getSelection()) == null ? void 0 : d.blocks) || [a.getTextCursorPosition().block];
    }
  }), r = o[0], i = S(
    () => (e.items || br(n.dictionary)).filter(
      (a) => J(
        n,
        a.type,
        Object.fromEntries(
          Object.entries(a.props || {}).map(([d, u]) => [
            d,
            typeof u
          ])
        )
      )
    ),
    [n, e.items]
  ), c = S(() => i.map((a) => {
    const d = a.icon, u = a.type === r.type, m = Object.entries(a.props || {}).filter(
      ([f, h]) => h !== r.props[f]
    ).length === 0;
    return {
      text: a.name,
      icon: /* @__PURE__ */ l(d, { size: 16 }),
      onClick: () => {
        n.focus(), n.transact(() => {
          for (const f of o)
            n.updateBlock(f, {
              type: a.type,
              props: a.props
            });
        });
      },
      isSelected: u && m
    };
  }), [
    n,
    i,
    r.props,
    r.type,
    o
  ]);
  return !S(
    () => c.find((a) => a.isSelected) !== void 0,
    [c]
  ) || !n.isEditable ? null : /* @__PURE__ */ l(
    t.FormattingToolbar.Select,
    {
      className: "bn-select",
      items: c
    }
  );
}, Cr = () => {
  const e = V(), t = v(), n = T("comments"), { store: o } = T(ne), r = k(() => {
    n.startPendingComment(), o.setState(!1);
  }, [n, o]);
  return /* @__PURE__ */ l(
    t.FormattingToolbar.Button,
    {
      className: "bn-button",
      label: e.formatting_toolbar.comment.tooltip,
      mainTooltip: e.formatting_toolbar.comment.tooltip,
      icon: /* @__PURE__ */ l(Ot, {}),
      onClick: r
    }
  );
}, vr = () => C().getExtension("comments") ? /* @__PURE__ */ l(Cr, {}) : null, wr = () => {
  const e = V(), t = v(), n = C(), o = k(() => {
    n._tiptapEditor.chain().focus().addPendingComment().run();
  }, [n]);
  return (
    // We manually check if a comment extension (like liveblocks) is installed
    // By adding default support for this, the user doesn't need to customize the formatting toolbar
    !n._tiptapEditor.commands.addPendingComment || !n.isEditable ? null : /* @__PURE__ */ l(
      t.FormattingToolbar.Button,
      {
        className: "bn-button",
        label: e.formatting_toolbar.comment.tooltip,
        mainTooltip: e.formatting_toolbar.comment.tooltip,
        icon: /* @__PURE__ */ l(Ot, {}),
        onClick: o
      }
    )
  );
};
function Ne(e, t) {
  try {
    const n = new URL(e, t);
    if (n.protocol !== "javascript:")
      return n.href;
  } catch {
  }
  return "#";
}
const kr = () => {
  const e = V(), t = v(), n = C(), o = R({
    editor: n,
    selector: ({ editor: i }) => {
      var a;
      const c = ((a = i.getSelection()) == null ? void 0 : a.blocks) || [
        i.getTextCursorPosition().block
      ];
      if (c.length !== 1)
        return;
      const s = c[0];
      if (A(s, i, s.type, {
        url: "string"
      }))
        return s;
    }
  }), r = k(() => {
    o !== void 0 && (n.focus(), n.resolveFileUrl ? n.resolveFileUrl(o.props.url).then(
      (i) => window.open(Ne(i, window.location.href))
    ) : window.open(Ne(o.props.url, window.location.href)));
  }, [o, n]);
  return o === void 0 ? null : /* @__PURE__ */ l(
    t.FormattingToolbar.Button,
    {
      className: "bn-button",
      label: e.formatting_toolbar.file_download.tooltip[o.type] || e.formatting_toolbar.file_download.tooltip.file,
      mainTooltip: e.formatting_toolbar.file_download.tooltip[o.type] || e.formatting_toolbar.file_download.tooltip.file,
      icon: /* @__PURE__ */ l(er, {}),
      onClick: r
    }
  );
}, Hr = () => {
  const e = V(), t = v(), n = C(), o = R({
    editor: n,
    selector: ({ editor: i }) => {
      var a;
      if (!i.isEditable)
        return;
      const c = ((a = i.getSelection()) == null ? void 0 : a.blocks) || [
        i.getTextCursorPosition().block
      ];
      if (c.length !== 1)
        return;
      const s = c[0];
      if (A(s, i, s.type, {
        url: "string",
        showPreview: "boolean"
      }))
        return s;
    }
  }), r = k(() => {
    o !== void 0 && J(n, o.type, {
      showPreview: "boolean"
    }) && n.updateBlock(o.id, {
      props: {
        showPreview: !o.props.showPreview
      }
    });
  }, [o, n]);
  return o === void 0 ? null : /* @__PURE__ */ l(
    t.FormattingToolbar.Button,
    {
      className: "bn-button",
      label: "Toggle preview",
      mainTooltip: e.formatting_toolbar.file_preview_toggle.tooltip,
      icon: /* @__PURE__ */ l(Wo, {}),
      isSelected: o.props.showPreview,
      onClick: r
    }
  );
}, xr = () => {
  const e = V(), t = v(), n = C(), o = T(L), r = R({
    editor: n,
    selector: ({ editor: c }) => {
      var d;
      if (!c.isEditable || !c.settings.tables.splitCells)
        return;
      const s = ((d = c.getSelection()) == null ? void 0 : d.blocks) || [
        c.getTextCursorPosition().block
      ];
      if (s.length !== 1)
        return;
      const a = s[0];
      if (a.type === "table")
        return {
          mergeDirection: o.getMergeDirection(a)
        };
    }
  }), i = k(() => {
    o == null || o.mergeCells();
  }, [o]);
  return r === void 0 ? null : /* @__PURE__ */ l(
    t.FormattingToolbar.Button,
    {
      className: "bn-button",
      label: e.formatting_toolbar.table_cell_merge.tooltip,
      mainTooltip: e.formatting_toolbar.table_cell_merge.tooltip,
      icon: r.mergeDirection === "horizontal" ? /* @__PURE__ */ l(Fo, {}) : /* @__PURE__ */ l(Go, {}),
      onClick: i
    }
  );
}, yr = {
  left: Ro,
  center: Eo,
  right: Oo,
  justify: Lo
}, Ee = (e) => {
  const t = v(), n = V(), o = C(), r = T(L), i = R({
    editor: o,
    selector: ({ editor: a }) => {
      var m;
      if (!a.isEditable)
        return;
      const d = ((m = a.getSelection()) == null ? void 0 : m.blocks) || [
        a.getTextCursorPosition().block
      ], u = d[0];
      if (A(u, a, u.type, {
        textAlignment: fe.textAlignment
      }))
        return {
          textAlignment: u.props.textAlignment,
          blocks: d
        };
      if (d.length === 1 && A(u, a, "table"))
        return r.getCellSelection() ? {
          textAlignment: ie(
            u.content.rows[0].cells[0]
          ).props.textAlignment,
          blocks: [u]
        } : void 0;
    }
  }), c = k(
    (a) => {
      if (i !== void 0) {
        o.focus();
        for (const d of i.blocks)
          if (A(d, o, d.type, {
            textAlignment: fe.textAlignment
          }) && J(o, d.type, {
            textAlignment: fe.textAlignment
          }))
            o.updateBlock(d, {
              props: { textAlignment: a }
            });
          else if (d.type === "table") {
            const u = r.getCellSelection();
            if (!u)
              continue;
            const m = d.content.rows.map(
              (f) => ({
                ...f,
                cells: f.cells.map((h) => ie(h))
              })
            );
            u.cells.forEach(({ row: f, col: h }) => {
              m[f].cells[h].props.textAlignment = a;
            }), o.updateBlock(d, {
              type: "table",
              content: {
                ...d.content,
                type: "tableContent",
                rows: m
              }
            }), o.setTextCursorPosition(d);
          }
      }
    },
    [o, i, r]
  );
  if (i === void 0)
    return null;
  const s = yr[e.textAlignment];
  return /* @__PURE__ */ l(
    t.FormattingToolbar.Button,
    {
      className: "bn-button",
      "data-test": `alignText${e.textAlignment.slice(0, 1).toUpperCase() + e.textAlignment.slice(1)}`,
      onClick: () => c(e.textAlignment),
      isSelected: i.textAlignment === e.textAlignment,
      label: n.formatting_toolbar[`align_${e.textAlignment}`].tooltip,
      mainTooltip: n.formatting_toolbar[`align_${e.textAlignment}`].tooltip,
      icon: /* @__PURE__ */ l(s, {})
    }
  );
}, Sr = (e) => [
  /* @__PURE__ */ l(pr, { items: e }, "blockTypeSelect"),
  /* @__PURE__ */ l(xr, {}, "tableCellMergeButton"),
  /* @__PURE__ */ l(dr, {}, "fileCaptionButton"),
  /* @__PURE__ */ l(fr, {}, "replaceFileButton"),
  /* @__PURE__ */ l(mr, {}, "fileRenameButton"),
  /* @__PURE__ */ l(ur, {}, "fileDeleteButton"),
  /* @__PURE__ */ l(kr, {}, "fileDownloadButton"),
  /* @__PURE__ */ l(Hr, {}, "filePreviewButton"),
  /* @__PURE__ */ l(de, { basicTextStyle: "bold" }, "boldStyleButton"),
  /* @__PURE__ */ l(de, { basicTextStyle: "italic" }, "italicStyleButton"),
  /* @__PURE__ */ l(
    de,
    {
      basicTextStyle: "underline"
    },
    "underlineStyleButton"
  ),
  /* @__PURE__ */ l(de, { basicTextStyle: "strike" }, "strikeStyleButton"),
  /* @__PURE__ */ l(Ee, { textAlignment: "left" }, "textAlignLeftButton"),
  /* @__PURE__ */ l(Ee, { textAlignment: "center" }, "textAlignCenterButton"),
  /* @__PURE__ */ l(Ee, { textAlignment: "right" }, "textAlignRightButton"),
  /* @__PURE__ */ l(cr, {}, "colorStyleButton"),
  /* @__PURE__ */ l(hr, {}, "nestBlockButton"),
  /* @__PURE__ */ l(gr, {}, "unnestBlockButton"),
  /* @__PURE__ */ l(sr, {}, "createLinkButton"),
  /* @__PURE__ */ l(vr, {}, "addCommentButton"),
  /* @__PURE__ */ l(wr, {}, "addTiptapCommentButton")
], Wt = (e) => {
  const t = v();
  return /* @__PURE__ */ l(
    t.FormattingToolbar.Root,
    {
      className: "bn-toolbar bn-formatting-toolbar",
      children: e.children || Sr(e.blockTypeSelectItems)
    }
  );
}, Vr = (e) => {
  switch (e) {
    case "left":
      return "top-start";
    case "center":
      return "top";
    case "right":
      return "top-end";
    default:
      return "top-start";
  }
}, Mr = (e) => {
  const t = C(), n = T(ne, {
    editor: t
  }), o = _(ne, {
    editor: t
  }), r = R({
    editor: t,
    selector: ({ editor: a }) => n.store.state ? {
      from: a.prosemirrorState.selection.from,
      to: a.prosemirrorState.selection.to
    } : void 0
  }), i = R({
    editor: t,
    selector: ({ editor: a }) => {
      const d = a.getTextCursorPosition().block;
      return A(d, a, d.type, {
        textAlignment: fe.textAlignment
      }) ? Vr(d.props.textAlignment) : "top-start";
    }
  }), c = S(
    () => ({
      useFloatingOptions: {
        open: o,
        // Needed as hooks like `useDismiss` call `onOpenChange` to change the
        // open state.
        onOpenChange: (a, d, u) => {
          n.store.setState(a), u === "escape-key" && t.focus();
        },
        placement: i,
        middleware: [j(10), ce(), Q()]
      },
      elementProps: {
        style: {
          zIndex: 40
        }
      },
      ...e.floatingUIOptions
    }),
    [o, i, e.floatingUIOptions, n.store, t]
  ), s = e.formattingToolbar || Wt;
  return /* @__PURE__ */ l(Ue, { position: r, ...c, children: o && /* @__PURE__ */ l(s, {}) });
}, Tr = (e) => {
  const t = v(), n = V(), { deleteLink: o } = T(ke);
  return /* @__PURE__ */ l(
    t.LinkToolbar.Button,
    {
      className: "bn-button",
      label: n.link_toolbar.delete.tooltip,
      mainTooltip: n.link_toolbar.delete.tooltip,
      isSelected: !1,
      onClick: () => {
        var r;
        o(e.range.from), (r = e.setToolbarOpen) == null || r.call(e, !1);
      },
      icon: /* @__PURE__ */ l(Do, {})
    }
  );
}, _r = (e) => {
  const t = v(), n = V();
  return /* @__PURE__ */ H(t.Generic.Popover.Root, { onOpenChange: e.setToolbarFrozen, children: [
    /* @__PURE__ */ l(t.Generic.Popover.Trigger, { children: /* @__PURE__ */ l(
      t.LinkToolbar.Button,
      {
        className: "bn-button",
        mainTooltip: n.link_toolbar.edit.tooltip,
        isSelected: !1,
        children: n.link_toolbar.edit.text
      }
    ) }),
    /* @__PURE__ */ l(
      t.Generic.Popover.Content,
      {
        className: "bn-popover-content bn-form-popover",
        variant: "form-popover",
        children: /* @__PURE__ */ l(
          $t,
          {
            url: e.url,
            text: e.text,
            range: e.range,
            setToolbarOpen: e.setToolbarOpen,
            setToolbarFrozen: e.setToolbarFrozen
          }
        )
      }
    )
  ] });
}, Br = (e) => {
  const t = v(), n = V();
  return /* @__PURE__ */ l(
    t.LinkToolbar.Button,
    {
      className: "bn-button",
      mainTooltip: n.link_toolbar.open.tooltip,
      label: n.link_toolbar.open.tooltip,
      isSelected: !1,
      onClick: () => {
        window.open(Ne(e.url, window.location.href), "_blank");
      },
      icon: /* @__PURE__ */ l(tr, {})
    }
  );
}, Er = (e) => {
  const t = v();
  return /* @__PURE__ */ l(t.LinkToolbar.Root, { className: "bn-toolbar bn-link-toolbar", children: e.children || /* @__PURE__ */ H(N, { children: [
    /* @__PURE__ */ l(
      _r,
      {
        url: e.url,
        text: e.text,
        range: e.range,
        setToolbarFrozen: e.setToolbarFrozen,
        setToolbarOpen: e.setToolbarOpen
      }
    ),
    /* @__PURE__ */ l(Br, { url: e.url }),
    /* @__PURE__ */ l(
      Tr,
      {
        range: e.range,
        setToolbarOpen: e.setToolbarOpen
      }
    )
  ] }) });
}, Lr = (e) => {
  const t = C(), [n, o] = M(!1), [r, i] = M(!1), c = T(ke), s = R({
    editor: t,
    selector: () => {
      const g = c.getLinkAtSelection();
      if (g)
        return {
          url: g.mark.attrs.href,
          text: g.text,
          range: g.range,
          element: c.getLinkElementAtPos(g.range.from)
        };
    }
  });
  y(() => {
    r || (o(!!s), s && d(void 0));
  }, [r, s]);
  const [a, d] = M(void 0);
  y(() => {
    const g = (b) => {
      if (s || !(b.target instanceof HTMLElement))
        return;
      const p = c.getLinkAtElement(b.target);
      p && d({
        url: p.mark.attrs.href,
        text: p.text,
        range: p.range,
        element: c.getLinkElementAtPos(p.range.from)
      });
    };
    return document.body.addEventListener("mouseover", g), () => {
      document.body.removeEventListener("mouseover", g);
    };
  }, [r, c, a == null ? void 0 : a.url, s]);
  const u = s || a, m = S(
    () => ({
      useFloatingOptions: {
        open: n,
        onOpenChange: (g, b, p) => {
          r || s && p === "hover" || (p === "escape-key" && t.focus(), o(g));
        },
        placement: "top-start",
        middleware: [j(10), Q()]
      },
      useHoverProps: {
        // `useHover` hook only enabled when a link is hovered with the
        // mouse.
        enabled: !s && !!a,
        delay: {
          open: 250,
          close: 250
        },
        handleClose: Sn()
      },
      elementProps: {
        style: {
          zIndex: 50
        }
      },
      ...e.floatingUIOptions
    }),
    [
      t,
      r,
      a,
      n,
      e.floatingUIOptions,
      s
    ]
  ), f = S(
    () => u != null && u.element ? { element: u.element } : void 0,
    [u == null ? void 0 : u.element]
  );
  if (!t.isEditable)
    return null;
  const h = e.linkToolbar || Er;
  return /* @__PURE__ */ l(U, { reference: f, ...m, children: u && /* @__PURE__ */ l(
    h,
    {
      url: u.url,
      text: u.text,
      range: u.range,
      setToolbarFrozen: i,
      setToolbarOpen: o
    }
  ) });
};
function Rr(e) {
  return w({ attr: { viewBox: "0 0 1024 1024" }, child: [{ tag: "path", attr: { d: "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8Z" }, child: [] }, { tag: "path", attr: { d: "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8Z" }, child: [] }] })(e);
}
const Or = () => {
  const e = v(), t = V(), n = C(), o = T(X), r = _(W, {
    editor: n,
    selector: (c) => c == null ? void 0 : c.block
  }), i = k(() => {
    if (r === void 0)
      return;
    const c = r.content;
    if (c !== void 0 && Array.isArray(c) && c.length === 0)
      n.setTextCursorPosition(r), o.openSuggestionMenu("/");
    else {
      const a = n.insertBlocks(
        [{ type: "paragraph" }],
        r,
        "after"
      )[0];
      n.setTextCursorPosition(a), o.openSuggestionMenu("/");
    }
  }, [r, n, o]);
  return r === void 0 ? null : /* @__PURE__ */ l(
    e.SideMenu.Button,
    {
      className: "bn-button",
      label: t.side_menu.add_block_label,
      icon: /* @__PURE__ */ l(Rr, { size: 24, onClick: i, "data-test": "dragHandleAdd" })
    }
  );
};
function qt(e) {
  return w({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0V0z" }, child: [] }, { tag: "path", attr: { d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" }, child: [] }] })(e);
}
function Ir(e) {
  return w({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "m7 10 5 5 5-5z" }, child: [] }] })(e);
}
const Pr = (e) => {
  const t = v(), n = C(), o = _(W, {
    editor: n,
    selector: (r) => r == null ? void 0 : r.block
  });
  return o === void 0 || !A(o, n, o.type, {
    textColor: "string"
  }) && !A(o, n, o.type, {
    backgroundColor: "string"
  }) ? null : /* @__PURE__ */ H(t.Generic.Menu.Root, { position: "right", sub: !0, children: [
    /* @__PURE__ */ l(t.Generic.Menu.Trigger, { sub: !0, children: /* @__PURE__ */ l(
      t.Generic.Menu.Item,
      {
        className: "bn-menu-item",
        subTrigger: !0,
        children: e.children
      }
    ) }),
    /* @__PURE__ */ l(
      t.Generic.Menu.Dropdown,
      {
        sub: !0,
        className: "bn-menu-dropdown bn-color-picker-dropdown",
        children: /* @__PURE__ */ l(
          xe,
          {
            iconSize: 18,
            text: A(o, n, o.type, {
              textColor: "string"
            }) && J(n, o.type, {
              textColor: "string"
            }) ? {
              color: o.props.textColor,
              setColor: (r) => n.updateBlock(o, {
                type: o.type,
                props: { textColor: r }
              })
            } : void 0,
            background: A(o, n, o.type, {
              backgroundColor: "string"
            }) && J(n, o.type, {
              backgroundColor: "string"
            }) ? {
              color: o.props.backgroundColor,
              setColor: (r) => n.updateBlock(o, {
                props: { backgroundColor: r }
              })
            } : void 0
          }
        )
      }
    )
  ] });
}, Nr = (e) => {
  const t = v(), n = C(), o = _(W, {
    editor: n,
    selector: (r) => r == null ? void 0 : r.block
  });
  return o === void 0 ? null : /* @__PURE__ */ l(
    t.Generic.Menu.Item,
    {
      className: "bn-menu-item",
      onClick: () => n.removeBlocks([o]),
      children: e.children
    }
  );
}, Ar = (e) => {
  const t = v(), n = C(), o = _(W, {
    editor: n,
    selector: (i) => i == null ? void 0 : i.block
  });
  if (o === void 0 || o.type !== "table" || !n.settings.tables.headers)
    return null;
  const r = !!o.content.headerRows;
  return /* @__PURE__ */ l(
    t.Generic.Menu.Item,
    {
      className: "bn-menu-item",
      checked: r,
      onClick: () => {
        n.updateBlock(o, {
          content: {
            ...o.content,
            headerRows: r ? void 0 : 1
          }
        });
      },
      children: e.children
    }
  );
}, Zr = (e) => {
  const t = v(), n = C(), o = _(W, {
    editor: n,
    selector: (i) => i == null ? void 0 : i.block
  });
  if (o === void 0 || o.type !== "table" || !n.settings.tables.headers)
    return null;
  const r = !!o.content.headerCols;
  return /* @__PURE__ */ l(
    t.Generic.Menu.Item,
    {
      className: "bn-menu-item",
      checked: r,
      onClick: () => {
        n.updateBlock(o, {
          content: {
            ...o.content,
            headerCols: r ? void 0 : 1
          }
        });
      },
      children: e.children
    }
  );
}, Dr = (e) => {
  const t = v(), n = V();
  return /* @__PURE__ */ l(
    t.Generic.Menu.Dropdown,
    {
      className: "bn-menu-dropdown bn-drag-handle-menu",
      children: e.children || /* @__PURE__ */ H(N, { children: [
        /* @__PURE__ */ l(Nr, { children: n.drag_handle.delete_menuitem }),
        /* @__PURE__ */ l(Pr, { children: n.drag_handle.colors_menuitem }),
        /* @__PURE__ */ l(Ar, { children: n.drag_handle.header_row_menuitem }),
        /* @__PURE__ */ l(Zr, { children: n.drag_handle.header_column_menuitem })
      ] })
    }
  );
}, Fr = (e) => {
  const t = v(), n = V(), o = T(W), r = _(W, {
    selector: (c) => c == null ? void 0 : c.block
  });
  if (r === void 0)
    return null;
  const i = e.dragHandleMenu || Dr;
  return /* @__PURE__ */ H(
    t.Generic.Menu.Root,
    {
      onOpenChange: (c) => {
        c ? o.freezeMenu() : o.unfreezeMenu();
      },
      position: "left",
      children: [
        /* @__PURE__ */ l(t.Generic.Menu.Trigger, { children: /* @__PURE__ */ l(
          t.SideMenu.Button,
          {
            label: n.side_menu.drag_handle_label,
            draggable: !0,
            onDragStart: (c) => o.blockDragStart(c, r),
            onDragEnd: o.blockDragEnd,
            className: "bn-button",
            icon: /* @__PURE__ */ l(qt, { size: 24, "data-test": "dragHandle" })
          }
        ) }),
        /* @__PURE__ */ l(i, { children: e.children })
      ]
    }
  );
}, Gr = (e) => {
  const t = v(), n = C(), o = _(W, {
    editor: n,
    selector: (i) => i == null ? void 0 : i.block
  }), r = S(() => {
    var c;
    if (o === void 0)
      return {};
    const i = {
      "data-block-type": o.type
    };
    return o.type === "heading" && (i["data-level"] = o.props.level.toString()), (c = n.schema.blockSpecs[o.type].implementation.meta) != null && c.fileBlockAccept && (o.props.url ? i["data-url"] = "true" : i["data-url"] = "false"), i;
  }, [o, n.schema.blockSpecs]);
  return /* @__PURE__ */ l(t.SideMenu.Root, { className: "bn-side-menu", ...r, children: e.children || /* @__PURE__ */ H(N, { children: [
    /* @__PURE__ */ l(Or, {}),
    /* @__PURE__ */ l(Fr, {})
  ] }) });
}, zr = (e) => {
  const t = _(W, {
    selector: (c) => c !== void 0 ? {
      show: c.show,
      block: c.block
    } : void 0
  }), { show: n, block: o } = t || {}, r = S(
    () => ({
      useFloatingOptions: {
        open: n,
        placement: "left-start"
      },
      useDismissProps: {
        enabled: !1
      },
      elementProps: {
        style: {
          zIndex: 20
        }
      },
      ...e.floatingUIOptions
    }),
    [e.floatingUIOptions, n]
  ), i = e.sideMenu || Gr;
  return /* @__PURE__ */ l(Bt, { blockId: n ? o == null ? void 0 : o.id : void 0, ...r, children: (o == null ? void 0 : o.id) && /* @__PURE__ */ l(i, {}) });
};
async function Ur(e, t) {
  return (await bn(e, t)).map(
    ({ id: n, onItemClick: o }) => ({
      id: n,
      onItemClick: o,
      icon: n
    })
  );
}
function jr(e) {
  const t = v(), n = V(), { items: o, loadingState: r, selectedIndex: i, onItemClick: c, columns: s } = e, a = r === "loading-initial" || r === "loading" ? /* @__PURE__ */ l(
    t.GridSuggestionMenu.Loader,
    {
      className: "bn-grid-suggestion-menu-loader",
      columns: s
    }
  ) : null, d = S(() => {
    const u = [];
    for (let m = 0; m < o.length; m++) {
      const f = o[m];
      u.push(
        /* @__PURE__ */ l(
          t.GridSuggestionMenu.Item,
          {
            className: "bn-grid-suggestion-menu-item",
            item: f,
            id: `bn-grid-suggestion-menu-item-${m}`,
            isSelected: m === i,
            onClick: () => c == null ? void 0 : c(f)
          },
          f.id
        )
      );
    }
    return u;
  }, [t, o, c, i]);
  return /* @__PURE__ */ H(
    t.GridSuggestionMenu.Root,
    {
      id: "bn-grid-suggestion-menu",
      columns: s,
      className: "bn-grid-suggestion-menu",
      children: [
        a,
        d,
        d.length === 0 && e.loadingState === "loaded" && /* @__PURE__ */ l(
          t.GridSuggestionMenu.EmptyItem,
          {
            className: "bn-grid-suggestion-menu-empty-item",
            columns: s,
            children: n.suggestion_menu.no_items_title
          }
        )
      ]
    }
  );
}
function Kt(e, t, n, o = 3) {
  const r = F(0);
  y(() => {
    t !== void 0 && (e.length > 0 ? r.current = t.length : t.length - r.current > o && n());
  }, [n, o, e.length, t]);
}
function Xt(e, t) {
  const [n, o] = M([]), [r, i] = M(!1), c = F(void 0), s = F(void 0);
  return y(() => {
    const a = e;
    c.current = e, i(!0), t(e).then((d) => {
      c.current === a && (o(d), i(!1), s.current = a);
    });
  }, [e, t]), {
    items: n || [],
    // The query that was used to retrieve the last set of items may not be the
    // same as the current query as the items from the current query may not
    // have been retrieved yet. This is useful when using the returns of this
    // hook in other hooks.
    usedQuery: s.current,
    loadingState: s.current === void 0 ? "loading-initial" : r ? "loading" : "loaded"
  };
}
function $r(e, t, n, o, r) {
  const [i, c] = M(0), s = o !== void 0 && o > 1;
  return y(() => {
    var d;
    const a = (u) => (u.key === "ArrowLeft" && (u.preventDefault(), n.length && c((i - 1 + n.length) % n.length)), u.key === "ArrowRight" && (u.preventDefault(), n.length && c((i + 1 + n.length) % n.length)), u.key === "ArrowUp" ? (u.preventDefault(), n.length && c(
      (i - o + n.length) % n.length
    ), !0) : u.key === "ArrowDown" ? (u.preventDefault(), n.length && c((i + o) % n.length), !0) : u.key === "Enter" && !u.isComposing ? (u.stopPropagation(), u.preventDefault(), n.length && (r == null || r(n[i])), !0) : !1);
    return (d = e.domElement) == null || d.addEventListener(
      "keydown",
      a,
      !0
    ), () => {
      var u;
      (u = e.domElement) == null || u.removeEventListener(
        "keydown",
        a,
        !0
      );
    };
  }, [e.domElement, n, i, r, o, s]), y(() => {
    c(0);
  }, [t]), {
    selectedIndex: n.length === 0 ? void 0 : i
  };
}
function Wr(e) {
  const n = q().setContentEditableProps, o = C(), {
    getItems: r,
    gridSuggestionMenuComponent: i,
    query: c,
    clearQuery: s,
    closeMenu: a,
    onItemClick: d,
    columns: u
  } = e, m = k(
    (x) => {
      a(), s(), d == null || d(x);
    },
    [d, a, s]
  ), { items: f, usedQuery: h, loadingState: g } = Xt(
    c,
    r
  );
  Kt(f, h, a);
  const { selectedIndex: b } = $r(
    o,
    c,
    f,
    u,
    m
  );
  return y(() => (n((x) => ({
    ...x,
    "aria-expanded": !0,
    "aria-controls": "bn-suggestion-menu"
  })), () => {
    n((x) => ({
      ...x,
      "aria-expanded": !1,
      "aria-controls": void 0
    }));
  }), [n]), y(() => (n((x) => ({
    ...x,
    "aria-activedescendant": b ? "bn-suggestion-menu-item-" + b : void 0
  })), () => {
    n((x) => ({
      ...x,
      "aria-activedescendant": void 0
    }));
  }), [n, b]), /* @__PURE__ */ l(
    i,
    {
      items: f,
      onItemClick: m,
      loadingState: g,
      selectedIndex: b,
      columns: u
    }
  );
}
function qr(e) {
  var b;
  const t = C(), {
    triggerCharacter: n,
    gridSuggestionMenuComponent: o,
    columns: r,
    minQueryLength: i,
    onItemClick: c,
    getItems: s
  } = e, a = S(() => c || ((p) => {
    p.onItemClick(t);
  }), [t, c]), d = S(() => s || (async (p) => await Ur(
    t,
    p
  )), [t, s]), u = T(X);
  y(() => {
    u.addTriggerCharacter(n);
  }, [u, n]);
  const m = _(X), f = _(X, {
    selector: (p) => (p == null ? void 0 : p.referencePos) || new DOMRect()
  }), h = S(
    () => {
      var p;
      return {
        // Use first child as the editor DOM element may itself be scrollable.
        // For FloatingUI to auto-update the position during scrolling, the
        // `contextElement` must be a descendant of the scroll container.
        element: ((p = t.domElement) == null ? void 0 : p.firstChild) || void 0,
        getBoundingClientRect: () => f
      };
    },
    [(b = t.domElement) == null ? void 0 : b.firstChild, f]
  ), g = S(
    () => ({
      useFloatingOptions: {
        open: (m == null ? void 0 : m.show) && (m == null ? void 0 : m.triggerCharacter) === n,
        onOpenChange: (p) => {
          p || u.closeMenu();
        },
        placement: "bottom-start",
        middleware: [
          j(10),
          // Flips the menu placement to maximize the space available, and prevents
          // the menu from being cut off by the confines of the screen.
          Q({
            mainAxis: !0,
            crossAxis: !1
          }),
          ce(),
          re({
            apply({ availableHeight: p, elements: x }) {
              Object.assign(x.floating.style, {
                maxHeight: `${p - 10}px`
              });
            }
          })
        ]
      },
      elementProps: {
        // Prevents editor blurring when clicking the scroll bar.
        onMouseDownCapture: (p) => p.preventDefault(),
        style: {
          zIndex: 70
        }
      },
      ...e.floatingUIOptions
    }),
    [
      e.floatingUIOptions,
      m == null ? void 0 : m.show,
      m == null ? void 0 : m.triggerCharacter,
      u,
      n
    ]
  );
  return !m || !m.ignoreQueryLength && i && (m.query.startsWith(" ") || m.query.length < i) ? null : /* @__PURE__ */ l(U, { reference: h, ...g, children: n && /* @__PURE__ */ l(
    Wr,
    {
      query: m.query,
      closeMenu: u.closeMenu,
      clearQuery: u.clearQuery,
      getItems: d,
      columns: r,
      gridSuggestionMenuComponent: o || jr,
      onItemClick: a
    }
  ) });
}
function Kr(e) {
  const t = v(), n = V(), { items: o, loadingState: r, selectedIndex: i, onItemClick: c } = e, s = r === "loading-initial" || r === "loading" ? /* @__PURE__ */ l(
    t.SuggestionMenu.Loader,
    {
      className: "bn-suggestion-menu-loader"
    }
  ) : null, a = S(() => {
    let d;
    const u = [];
    for (let m = 0; m < o.length; m++) {
      const f = o[m];
      f.group !== d && (d = f.group, u.push(
        /* @__PURE__ */ l(
          t.SuggestionMenu.Label,
          {
            className: "bn-suggestion-menu-label",
            children: d
          },
          d
        )
      )), u.push(
        /* @__PURE__ */ l(
          t.SuggestionMenu.Item,
          {
            className: Z(
              "bn-suggestion-menu-item",
              f.size === "small" ? "bn-suggestion-menu-item-small" : ""
            ),
            item: f,
            id: `bn-suggestion-menu-item-${m}`,
            isSelected: m === i,
            onClick: () => c == null ? void 0 : c(f)
          },
          f.title
        )
      );
    }
    return u;
  }, [t, o, c, i]);
  return /* @__PURE__ */ H(
    t.SuggestionMenu.Root,
    {
      id: "bn-suggestion-menu",
      className: "bn-suggestion-menu",
      children: [
        a,
        a.length === 0 && (e.loadingState === "loading" || e.loadingState === "loaded") && /* @__PURE__ */ l(
          t.SuggestionMenu.EmptyItem,
          {
            className: "bn-suggestion-menu-item",
            children: n.suggestion_menu.no_items_title
          }
        ),
        s
      ]
    }
  );
}
function Xr(e, t) {
  const [n, o] = M(0);
  return {
    selectedIndex: n,
    setSelectedIndex: o,
    handler: (r) => {
      if (r.key === "ArrowUp")
        return r.preventDefault(), e.length && o((n - 1 + e.length) % e.length), !0;
      if (r.key === "ArrowDown")
        return r.preventDefault(), e.length && o((n + 1) % e.length), !0;
      const i = Yr(r) ? r.nativeEvent.isComposing : r.isComposing;
      return r.key === "Enter" && !i ? (r.preventDefault(), r.stopPropagation(), e.length && (t == null || t(e[n])), !0) : !1;
    }
  };
}
function Yr(e) {
  return e.nativeEvent !== void 0;
}
function Jr(e, t, n, o, r) {
  const { selectedIndex: i, setSelectedIndex: c, handler: s } = Xr(n, o);
  return y(() => {
    var a;
    return (a = r || e.domElement) == null || a.addEventListener("keydown", s, !0), () => {
      var d;
      (d = r || e.domElement) == null || d.removeEventListener(
        "keydown",
        s,
        !0
      );
    };
  }, [e.domElement, n, i, o, r, s]), y(() => {
    c(0);
  }, [t, c]), {
    selectedIndex: n.length === 0 ? void 0 : i
  };
}
function Qr(e) {
  const n = q().setContentEditableProps, o = C(), {
    getItems: r,
    suggestionMenuComponent: i,
    query: c,
    clearQuery: s,
    closeMenu: a,
    onItemClick: d
  } = e, u = k(
    (p) => {
      a(), s(), d == null || d(p);
    },
    [d, a, s]
  ), { items: m, usedQuery: f, loadingState: h } = Xt(
    c,
    r
  );
  Kt(m, f, a);
  const { selectedIndex: g } = Jr(
    o,
    c,
    m,
    u
  );
  return y(() => (n((p) => ({
    ...p,
    "aria-expanded": !0,
    "aria-controls": "bn-suggestion-menu"
  })), () => {
    n((p) => ({
      ...p,
      "aria-expanded": !1,
      "aria-controls": void 0
    }));
  }), [n]), y(() => (n((p) => ({
    ...p,
    "aria-activedescendant": g ? "bn-suggestion-menu-item-" + g : void 0
  })), () => {
    n((p) => ({
      ...p,
      "aria-activedescendant": void 0
    }));
  }), [n, g]), /* @__PURE__ */ l(
    i,
    {
      items: m,
      onItemClick: u,
      loadingState: h,
      selectedIndex: g
    }
  );
}
const ei = {
  heading: pe,
  heading_2: Ce,
  heading_3: ve,
  heading_4: It,
  heading_5: Pt,
  heading_6: Nt,
  toggle_heading: pe,
  toggle_heading_2: Ce,
  toggle_heading_3: ve,
  quote: Gt,
  toggle_list: Ut,
  numbered_list: Dt,
  bullet_list: Ft,
  check_list: Zt,
  paragraph: $e,
  table: Uo,
  image: zt,
  video: $o,
  audio: jt,
  file: je,
  emoji: rr,
  code_block: Po,
  divider: or
};
function ti(e) {
  return pn(e).map((t) => {
    const n = ei[t.key];
    return {
      ...t,
      icon: /* @__PURE__ */ l(n, { size: 18 })
    };
  });
}
function ni(e) {
  var g;
  const t = C(), {
    triggerCharacter: n,
    suggestionMenuComponent: o,
    minQueryLength: r,
    onItemClick: i,
    getItems: c
  } = e, s = S(() => i || ((b) => {
    b.onItemClick(t);
  }), [t, i]), a = S(() => c || (async (b) => Cn(
    ti(t),
    b
  )), [t, c]), d = T(X);
  y(() => {
    d.addTriggerCharacter(n);
  }, [d, n]);
  const u = _(X), m = _(X, {
    selector: (b) => (b == null ? void 0 : b.referencePos) || new DOMRect()
  }), f = S(
    () => {
      var b;
      return {
        // Use first child as the editor DOM element may itself be scrollable.
        // For FloatingUI to auto-update the position during scrolling, the
        // `contextElement` must be a descendant of the scroll container.
        element: ((b = t.domElement) == null ? void 0 : b.firstChild) || void 0,
        getBoundingClientRect: () => m
      };
    },
    [(g = t.domElement) == null ? void 0 : g.firstChild, m]
  ), h = S(
    () => ({
      useFloatingOptions: {
        open: (u == null ? void 0 : u.show) && (u == null ? void 0 : u.triggerCharacter) === n,
        onOpenChange: (b) => {
          b || d.closeMenu();
        },
        placement: "bottom-start",
        middleware: [
          j(10),
          // Flips the menu placement to maximize the space available, and prevents
          // the menu from being cut off by the confines of the screen.
          Q({
            mainAxis: !0,
            crossAxis: !1
          }),
          ce(),
          re({
            apply({ availableHeight: b, elements: p }) {
              Object.assign(p.floating.style, {
                maxHeight: `${b - 10}px`,
                minHeight: "300px"
              });
            }
          })
        ]
      },
      elementProps: {
        // Prevents editor blurring when clicking the scroll bar.
        onMouseDownCapture: (b) => b.preventDefault(),
        style: {
          zIndex: 80
        }
      },
      ...e.floatingUIOptions
    }),
    [
      e.floatingUIOptions,
      u == null ? void 0 : u.show,
      u == null ? void 0 : u.triggerCharacter,
      d,
      n
    ]
  );
  return !u || !u.ignoreQueryLength && r && (u.query.startsWith(" ") || u.query.length < r) ? null : /* @__PURE__ */ l(U, { reference: f, ...h, children: n && /* @__PURE__ */ l(
    Qr,
    {
      query: u.query,
      closeMenu: d.closeMenu,
      clearQuery: d.clearQuery,
      getItems: a,
      suggestionMenuComponent: o || Kr,
      onItemClick: s
    }
  ) });
}
const oi = (e, t = 0.3) => {
  const n = Math.floor(e) + t, o = Math.ceil(e) - t;
  return e >= n && e <= o ? Math.round(e) : e < n ? Math.floor(e) : Math.ceil(e);
}, ri = (e) => {
  const t = v(), n = C(), o = T(L), r = _(L, {
    selector: (u) => u == null ? void 0 : u.block
  }), i = F(!1), [c, s] = M(), a = k(
    (u) => {
      o.freezeHandles(), e.hideOtherElements(!0), r && (s({
        originalContent: r.content,
        originalCroppedContent: {
          rows: o.cropEmptyRowsOrColumns(
            r,
            e.orientation === "addOrRemoveColumns" ? "columns" : "rows"
          )
        },
        startPos: e.orientation === "addOrRemoveColumns" ? u.clientX : u.clientY
      }), i.current = !1, u.preventDefault());
    },
    [r, e, o]
  ), d = k(() => {
    !r || i.current || n.updateBlock(r, {
      type: "table",
      content: {
        ...r.content,
        rows: e.orientation === "addOrRemoveColumns" ? o.addRowsOrColumns(r, "columns", 1) : o.addRowsOrColumns(r, "rows", 1)
      }
    });
  }, [r, n, e.orientation, o]);
  return y(() => {
    const u = (m) => {
      var x, I;
      if (!r)
        return;
      if (!c)
        throw new Error("editingState is undefined");
      i.current = !0;
      const f = (e.orientation === "addOrRemoveColumns" ? m.clientX : m.clientY) - c.startPos, h = e.orientation === "addOrRemoveColumns" ? ((x = c.originalCroppedContent.rows[0]) == null ? void 0 : x.cells.length) ?? 0 : c.originalCroppedContent.rows.length, g = e.orientation === "addOrRemoveColumns" ? ((I = c.originalContent.rows[0]) == null ? void 0 : I.cells.length) ?? 0 : c.originalContent.rows.length, b = e.orientation === "addOrRemoveColumns" ? r.content.rows[0].cells.length : r.content.rows.length, p = g + oi(
        f / (e.orientation === "addOrRemoveColumns" ? Mn : Tn),
        0.3
      );
      p >= h && p > 0 && p !== b && (n.updateBlock(r, {
        type: "table",
        content: {
          ...r.content,
          rows: e.orientation === "addOrRemoveColumns" ? o.addRowsOrColumns(
            {
              type: "table",
              content: c.originalCroppedContent
            },
            "columns",
            p - h
          ) : o.addRowsOrColumns(
            {
              type: "table",
              content: c.originalCroppedContent
            },
            "rows",
            p - h
          )
        }
      }), r.content && n.setTextCursorPosition(r));
    };
    return c && window.addEventListener("mousemove", u), () => {
      window.removeEventListener("mousemove", u);
    };
  }, [r, c, n, e.orientation, o]), y(() => {
    const u = () => {
      e.hideOtherElements(!1), o.unfreezeHandles(), s(void 0);
    };
    return c && window.addEventListener("mouseup", u), () => {
      window.removeEventListener("mouseup", u);
    };
  }, [c, e, o]), n.isEditable ? /* @__PURE__ */ l(
    t.TableHandle.ExtendButton,
    {
      className: Z(
        "bn-extend-button",
        e.orientation === "addOrRemoveColumns" ? "bn-extend-button-add-remove-columns" : "bn-extend-button-add-remove-rows",
        c !== null ? "bn-extend-button-editing" : ""
      ),
      onClick: d,
      onMouseDown: a,
      children: e.children || /* @__PURE__ */ l(Xo, { size: 18, "data-test": "extendButton" })
    }
  ) : null;
}, ht = (e) => {
  const t = v(), n = V(), o = T(L), r = _(L, {
    selector: (i) => e.orientation === "column" ? i == null ? void 0 : i.colIndex : i == null ? void 0 : i.rowIndex
  });
  return o === void 0 || r === void 0 ? null : /* @__PURE__ */ l(
    t.Generic.Menu.Item,
    {
      onClick: () => {
        o.addRowOrColumn(
          r,
          e.orientation === "row" ? { orientation: "row", side: e.side } : { orientation: "column", side: e.side }
        );
      },
      children: n.table_handle[`add_${e.side}_menuitem`]
    }
  );
}, ii = (e) => {
  const t = v(), n = V(), o = T(L), r = _(L, {
    selector: (i) => e.orientation === "column" ? i == null ? void 0 : i.colIndex : i == null ? void 0 : i.rowIndex
  });
  return o === void 0 || r === void 0 ? null : /* @__PURE__ */ l(
    t.Generic.Menu.Item,
    {
      onClick: () => o.removeRowOrColumn(r, e.orientation),
      children: e.orientation === "row" ? n.table_handle.delete_row_menuitem : n.table_handle.delete_column_menuitem
    }
  );
}, li = (e) => {
  const t = v(), n = V(), o = C(), r = T(L), { block: i, index: c } = _(L, {
    selector: (u) => ({
      block: u == null ? void 0 : u.block,
      index: e.orientation === "column" ? u == null ? void 0 : u.colIndex : u == null ? void 0 : u.rowIndex
    })
  }), s = S(() => r === void 0 || i === void 0 || c === void 0 ? [] : e.orientation === "row" ? r.getCellsAtRowHandle(i, c) : r.getCellsAtColumnHandle(i, c), [i, c, e.orientation, r]), a = (u, m) => {
    if (i === void 0)
      return;
    const f = i.content.rows.map((h) => ({
      ...h,
      cells: h.cells.map((g) => ie(g))
    }));
    s.forEach(({ row: h, col: g }) => {
      m === "text" ? f[h].cells[g].props.textColor = u : f[h].cells[g].props.backgroundColor = u;
    }), o.updateBlock(i, {
      type: "table",
      content: {
        ...i.content,
        rows: f
      }
    }), o.setTextCursorPosition(i);
  };
  if (!s || !s[0] || !r || o.settings.tables.cellTextColor === !1 && o.settings.tables.cellBackgroundColor === !1)
    return null;
  const d = ie(s[0].cell);
  return /* @__PURE__ */ H(t.Generic.Menu.Root, { position: "right", sub: !0, children: [
    /* @__PURE__ */ l(t.Generic.Menu.Trigger, { sub: !0, children: /* @__PURE__ */ l(
      t.Generic.Menu.Item,
      {
        className: "bn-menu-item",
        subTrigger: !0,
        children: e.children || n.drag_handle.colors_menuitem
      }
    ) }),
    /* @__PURE__ */ l(
      t.Generic.Menu.Dropdown,
      {
        sub: !0,
        className: "bn-menu-dropdown bn-color-picker-dropdown",
        children: /* @__PURE__ */ l(
          xe,
          {
            iconSize: 18,
            text: o.settings.tables.cellTextColor ? {
              // All cells have the same text color
              color: s.every(
                ({ cell: u }) => le(u) && u.props.textColor === d.props.textColor
              ) ? d.props.textColor : "default",
              setColor: (u) => {
                a(u, "text");
              }
            } : void 0,
            background: o.settings.tables.cellBackgroundColor ? {
              color: s.every(
                ({ cell: u }) => le(u) && u.props.backgroundColor === d.props.backgroundColor
              ) ? d.props.backgroundColor : "default",
              setColor: (u) => a(u, "background")
            } : void 0
          }
        )
      }
    )
  ] });
}, ci = (e) => {
  const t = v(), n = V(), o = C(), r = T(L), { block: i, index: c } = _(L, {
    selector: (a) => ({
      block: a == null ? void 0 : a.block,
      index: e.orientation === "column" ? a == null ? void 0 : a.colIndex : a == null ? void 0 : a.rowIndex
    })
  });
  if (r === void 0 || i === void 0 || c !== 0 || e.orientation !== "row" || !o.settings.tables.headers)
    return null;
  const s = !!i.content.headerRows;
  return /* @__PURE__ */ l(
    t.Generic.Menu.Item,
    {
      className: "bn-menu-item",
      checked: s,
      onClick: () => {
        o.updateBlock(i, {
          ...i,
          content: {
            ...i.content,
            headerRows: s ? void 0 : 1
          }
        });
      },
      children: n.drag_handle.header_row_menuitem
    }
  );
}, ai = (e) => {
  const t = v(), n = V(), o = C(), r = T(L), i = _(L, {
    selector: (a) => a == null ? void 0 : a.block
  }), c = _(L, {
    selector: (a) => e.orientation === "column" ? a == null ? void 0 : a.colIndex : a == null ? void 0 : a.rowIndex
  });
  if (!r || c !== 0 || !i || e.orientation !== "column" || !o.settings.tables.headers)
    return null;
  const s = !!i.content.headerCols;
  return /* @__PURE__ */ l(
    t.Generic.Menu.Item,
    {
      className: "bn-menu-item",
      checked: s,
      onClick: () => {
        o.updateBlock(i, {
          ...i,
          content: {
            ...i.content,
            headerCols: s ? void 0 : 1
          }
        });
      },
      children: n.drag_handle.header_column_menuitem
    }
  );
}, si = (e) => {
  const t = v();
  return /* @__PURE__ */ l(t.Generic.Menu.Dropdown, { className: "bn-table-handle-menu", children: e.children || /* @__PURE__ */ H(N, { children: [
    /* @__PURE__ */ l(ii, { orientation: e.orientation }),
    /* @__PURE__ */ l(
      ht,
      {
        orientation: e.orientation,
        side: e.orientation === "row" ? "above" : "left"
      }
    ),
    /* @__PURE__ */ l(
      ht,
      {
        orientation: e.orientation,
        side: e.orientation === "row" ? "below" : "right"
      }
    ),
    /* @__PURE__ */ l(ci, { orientation: e.orientation }),
    /* @__PURE__ */ l(ai, { orientation: e.orientation }),
    /* @__PURE__ */ l(li, { orientation: e.orientation })
  ] }) });
}, di = (e) => {
  const t = C(), n = v(), [o, r] = M(!1), i = e.tableHandleMenu || si, c = T(L), s = _(L), a = S(() => !c || !s || !s.block || s.block.type !== "table" ? !1 : e.orientation === "column" ? c.getCellsAtColumnHandle(s.block, s.colIndex).every(({ cell: d }) => wt(d) === 1) : c.getCellsAtRowHandle(s.block, s.rowIndex).every(({ cell: d }) => kt(d) === 1), [e.orientation, s, c]);
  return s ? /* @__PURE__ */ H(
    n.Generic.Menu.Root,
    {
      onOpenChange: (d) => {
        d ? (c.freezeHandles(), e.hideOtherElements(!0)) : (c.unfreezeHandles(), e.hideOtherElements(!1), t.focus());
      },
      position: "right",
      children: [
        /* @__PURE__ */ l(n.Generic.Menu.Trigger, { children: /* @__PURE__ */ l(
          n.TableHandle.Root,
          {
            className: Z(
              "bn-table-handle",
              o ? "bn-table-handle-dragging" : "",
              a ? "" : "bn-table-handle-not-draggable"
            ),
            draggable: a,
            onDragStart: (d) => {
              r(!0), e.hideOtherElements(!0), e.orientation === "column" ? c.colDragStart(d) : c.rowDragStart(d);
            },
            onDragEnd: () => {
              c.dragEnd(), e.hideOtherElements(!1), r(!1);
            },
            style: e.orientation === "column" ? { transform: "rotate(0.25turn)" } : void 0,
            children: e.children || /* @__PURE__ */ l(qt, { size: 24, "data-test": "tableHandle" })
          }
        ) }),
        /* @__PURE__ */ l(i, { orientation: e.orientation })
      ]
    }
  ) : null;
}, ui = (e) => {
  var d, u;
  const t = v(), n = V(), o = C(), { block: r, colIndex: i, rowIndex: c } = _(
    L,
    {
      selector: (m) => ({
        block: m == null ? void 0 : m.block,
        colIndex: m == null ? void 0 : m.colIndex,
        rowIndex: m == null ? void 0 : m.rowIndex
      })
    }
  ), s = (m, f) => {
    if (r === void 0 || i === void 0 || c === void 0)
      return;
    const h = r.content.rows.map((g) => ({
      ...g,
      cells: g.cells.map((b) => ie(b))
    }));
    f === "text" ? h[c].cells[i].props.textColor = m : h[c].cells[i].props.backgroundColor = m, o.updateBlock(r, {
      type: "table",
      content: {
        ...r.content,
        rows: h
      }
    }), o.setTextCursorPosition(r);
  };
  if (r === void 0 || i === void 0 || c === void 0)
    return null;
  const a = (u = (d = r.content.rows[c]) == null ? void 0 : d.cells) == null ? void 0 : u[i];
  return !a || o.settings.tables.cellTextColor === !1 && o.settings.tables.cellBackgroundColor === !1 ? null : /* @__PURE__ */ H(t.Generic.Menu.Root, { position: "right", sub: !0, children: [
    /* @__PURE__ */ l(t.Generic.Menu.Trigger, { sub: !0, children: /* @__PURE__ */ l(
      t.Generic.Menu.Item,
      {
        className: "bn-menu-item",
        subTrigger: !0,
        children: e.children || n.drag_handle.colors_menuitem
      }
    ) }),
    /* @__PURE__ */ l(
      t.Generic.Menu.Dropdown,
      {
        sub: !0,
        className: "bn-menu-dropdown bn-color-picker-dropdown",
        children: /* @__PURE__ */ l(
          xe,
          {
            iconSize: 18,
            text: o.settings.tables.cellTextColor ? {
              color: le(a) ? a.props.textColor : "default",
              setColor: (m) => s(m, "text")
            } : void 0,
            background: o.settings.tables.cellBackgroundColor ? {
              color: le(a) ? a.props.backgroundColor : "default",
              setColor: (m) => s(m, "background")
            } : void 0
          }
        )
      }
    )
  ] });
}, mi = () => {
  var a, d;
  const e = v(), t = V(), n = C(), o = T(L), { block: r, colIndex: i, rowIndex: c } = _(
    L,
    {
      selector: (u) => ({
        block: u == null ? void 0 : u.block,
        colIndex: u == null ? void 0 : u.colIndex,
        rowIndex: u == null ? void 0 : u.rowIndex
      })
    }
  );
  if (r === void 0 || i === void 0 || c === void 0)
    return null;
  const s = (d = (a = r.content.rows[c]) == null ? void 0 : a.cells) == null ? void 0 : d[i];
  return !s || !le(s) || kt(s) === 1 && wt(s) === 1 || !n.settings.tables.splitCells ? null : /* @__PURE__ */ l(
    e.Generic.Menu.Item,
    {
      onClick: () => {
        o.splitCell({
          row: c,
          col: i
        });
      },
      children: t.table_handle.split_cell_menuitem
    }
  );
}, fi = (e) => {
  const t = v();
  return /* @__PURE__ */ l(
    t.Generic.Menu.Dropdown,
    {
      className: "bn-menu-dropdown bn-table-handle-menu",
      children: e.children || /* @__PURE__ */ H(N, { children: [
        /* @__PURE__ */ l(mi, {}),
        /* @__PURE__ */ l(ui, {})
      ] })
    }
  );
}, hi = (e) => {
  const t = v(), n = C(), o = T(L), r = e.tableCellMenu || fi;
  return !n.settings.tables.splitCells && !n.settings.tables.cellBackgroundColor && !n.settings.tables.cellTextColor ? null : /* @__PURE__ */ H(
    t.Generic.Menu.Root,
    {
      onOpenChange: (i) => {
        i ? (o.freezeHandles(), e.hideOtherElements(!0)) : (o.unfreezeHandles(), e.hideOtherElements(!1), n.focus());
      },
      position: "right",
      children: [
        /* @__PURE__ */ l(t.Generic.Menu.Trigger, { children: /* @__PURE__ */ l(t.Generic.Menu.Button, { className: "bn-table-cell-handle", children: e.children || /* @__PURE__ */ l(Ir, { size: 12, "data-test": "tableCellHandle" }) }) }),
        /* @__PURE__ */ l(r, {})
      ]
    }
  );
}, gi = (e) => {
  const t = C(), [n, o] = M(), r = _(L), i = S(() => {
    if (r === void 0 || r.rowIndex === void 0 || r.colIndex === void 0)
      return {};
    const d = Ge(
      r.block.id,
      t.prosemirrorState.doc
    );
    if (!d)
      return {};
    const u = d.posBeforeNode + 1, m = t.prosemirrorView.domAtPos(
      u + 1
    ).node;
    if (!(m instanceof Element))
      return {};
    const f = { element: m }, h = t.prosemirrorState.doc.resolve(u + 1).posAtIndex(r.rowIndex), g = t.prosemirrorState.doc.resolve(h + 1).posAtIndex(r.colIndex), b = t.prosemirrorView.domAtPos(g + 1).node;
    return b instanceof Element ? {
      tableReference: f,
      cellReference: { element: b },
      rowReference: {
        element: m,
        getBoundingClientRect: () => {
          const O = m.getBoundingClientRect(), E = b.getBoundingClientRect();
          return new DOMRect(
            O.x,
            r.draggingState && r.draggingState.draggedCellOrientation === "row" ? r.draggingState.mousePos - E.height / 2 : E.y,
            O.width,
            E.height
          );
        }
      },
      columnReference: {
        element: m,
        getBoundingClientRect: () => {
          const O = m.getBoundingClientRect(), E = b.getBoundingClientRect();
          return new DOMRect(
            r.draggingState && r.draggingState.draggedCellOrientation === "col" ? r.draggingState.mousePos - E.width / 2 : E.x,
            O.y,
            E.width,
            O.height
          );
        }
      }
    } : {};
  }, [t, r]);
  if (!r)
    return null;
  const c = e.tableHandle || di, s = e.extendButton || ri, a = e.tableCellHandle || hi;
  return /* @__PURE__ */ H(N, { children: [
    /* @__PURE__ */ l(
      U,
      {
        reference: i == null ? void 0 : i.rowReference,
        useFloatingOptions: {
          open: r.show && r.rowIndex !== void 0 && (!n || n === "rowTableHandle"),
          placement: "left",
          middleware: [j(-10)]
        },
        elementProps: {
          style: {
            zIndex: 10
          }
        },
        children: r.show && r.rowIndex !== void 0 && (!n || n === "rowTableHandle") && /* @__PURE__ */ l(
          c,
          {
            orientation: "row",
            hideOtherElements: (d) => o(d ? "rowTableHandle" : void 0)
          }
        )
      }
    ),
    /* @__PURE__ */ l(
      U,
      {
        reference: i == null ? void 0 : i.columnReference,
        useFloatingOptions: {
          open: r.show && r.colIndex !== void 0 && (!n || n === "columnTableHandle"),
          placement: "top",
          middleware: [j(-12)]
        },
        elementProps: {
          style: {
            zIndex: 10
          }
        },
        children: r.show && r.colIndex !== void 0 && (!n || n === "columnTableHandle") && /* @__PURE__ */ l(
          c,
          {
            orientation: "column",
            hideOtherElements: (d) => o(d ? "columnTableHandle" : void 0)
          }
        )
      }
    ),
    /* @__PURE__ */ l(
      U,
      {
        reference: i == null ? void 0 : i.cellReference,
        useFloatingOptions: {
          open: r.show && r.rowIndex !== void 0 && r.colIndex !== void 0 && (!n || n === "tableCellHandle"),
          placement: "top-end",
          middleware: [j({ mainAxis: -15, crossAxis: -1 })]
        },
        elementProps: {
          style: {
            zIndex: 10
          }
        },
        children: r.show && r.rowIndex !== void 0 && r.colIndex !== void 0 && (!n || n === "tableCellHandle") && /* @__PURE__ */ l(
          a,
          {
            hideOtherElements: (d) => o(d ? "tableCellHandle" : void 0)
          }
        )
      }
    ),
    /* @__PURE__ */ l(
      U,
      {
        reference: i == null ? void 0 : i.tableReference,
        useFloatingOptions: {
          open: r.show && r.showAddOrRemoveRowsButton && (!n || n === "extendRowsButton"),
          placement: "bottom",
          middleware: [
            re({
              apply({ rects: d, elements: u }) {
                Object.assign(u.floating.style, {
                  width: `${d.reference.width}px`
                });
              }
            })
          ]
        },
        elementProps: {
          style: {
            zIndex: 10
          }
        },
        children: r.show && r.showAddOrRemoveRowsButton && (!n || n === "extendRowsButton") && /* @__PURE__ */ l(
          s,
          {
            orientation: "addOrRemoveRows",
            hideOtherElements: (d) => o(d ? "extendRowsButton" : void 0)
          }
        )
      }
    ),
    /* @__PURE__ */ l(
      U,
      {
        reference: i == null ? void 0 : i.tableReference,
        useFloatingOptions: {
          open: r.show && r.showAddOrRemoveColumnsButton && (!n || n === "extendColumnsButton"),
          placement: "right",
          middleware: [
            re({
              apply({ rects: d, elements: u }) {
                Object.assign(u.floating.style, {
                  height: `${d.reference.height}px`
                });
              }
            })
          ]
        },
        elementProps: {
          style: {
            zIndex: 10
          }
        },
        children: r.show && r.showAddOrRemoveColumnsButton && (!n || n === "extendColumnsButton") && /* @__PURE__ */ l(
          s,
          {
            orientation: "addOrRemoveColumns",
            hideOtherElements: (d) => o(d ? "extendColumnsButton" : void 0)
          }
        )
      }
    )
  ] });
}, bi = vt(
  () => Promise.resolve().then(() => rl)
), pi = vt(
  () => Promise.resolve().then(() => ll)
);
function Ci(e) {
  const t = C();
  if (!t)
    throw new Error(
      "BlockNoteDefaultUI must be used within a BlockNoteContext.Provider"
    );
  return /* @__PURE__ */ H(N, { children: [
    t.getExtension(ne) && e.formattingToolbar !== !1 && /* @__PURE__ */ l(Mr, {}),
    t.getExtension(ke) && e.linkToolbar !== !1 && /* @__PURE__ */ l(Lr, {}),
    t.getExtension(X) && e.slashMenu !== !1 && /* @__PURE__ */ l(ni, { triggerCharacter: "/" }),
    t.getExtension(X) && e.emojiPicker !== !1 && /* @__PURE__ */ l(
      qr,
      {
        triggerCharacter: ":",
        columns: 10,
        minQueryLength: 2
      }
    ),
    t.getExtension(W) && e.sideMenu !== !1 && /* @__PURE__ */ l(zr, {}),
    t.getExtension(he) && e.filePanel !== !1 && /* @__PURE__ */ l(so, {}),
    t.getExtension(L) && e.tableHandles !== !1 && /* @__PURE__ */ l(gi, {}),
    t.getExtension(G) && e.comments !== !1 && /* @__PURE__ */ H(sn, { children: [
      /* @__PURE__ */ l(bi, {}),
      /* @__PURE__ */ l(pi, {})
    ] })
  ] });
}
function vi(e, t) {
  const n = q();
  t || (t = n == null ? void 0 : n.editor), y(() => {
    if (!t)
      throw new Error(
        "'editor' is required, either from BlockNoteContext or as a function argument"
      );
    return t.onChange(e);
  }, [e, t]);
}
function wi(e, t, n) {
  const o = q();
  t || (t = o == null ? void 0 : o.editor), y(() => {
    if (!t)
      throw new Error(
        "'editor' is required, either from BlockNoteContext or as a function argument"
      );
    return t.onSelectionChange(e, n);
  }, [e, t, n]);
}
const ki = () => {
  const e = S(
    () => {
      var c;
      return (c = window.matchMedia) == null ? void 0 : c.call(window, "(prefers-color-scheme: dark)");
    },
    []
  ), t = S(
    () => {
      var c;
      return (c = window.matchMedia) == null ? void 0 : c.call(window, "(prefers-color-scheme: light)");
    },
    []
  ), n = e == null ? void 0 : e.matches, o = t == null ? void 0 : t.matches, [r, i] = M(n ? "dark" : o ? "light" : "no-preference");
  return y(() => {
    i(n ? "dark" : o ? "light" : "no-preference");
  }, [n, o]), y(() => {
    if (typeof (e == null ? void 0 : e.addEventListener) == "function") {
      const c = ({ matches: a }) => a && i("dark"), s = ({ matches: a }) => a && i("light");
      return e == null || e.addEventListener("change", c), t == null || t.addEventListener("change", s), () => {
        e == null || e.removeEventListener("change", c), t == null || t.removeEventListener("change", s);
      };
    } else {
      const c = () => i(
        e.matches ? "dark" : t.matches ? "light" : "no-preference"
      );
      return e == null || e.addEventListener("change", c), t == null || t.addEventListener("change", c), () => {
        e == null || e.removeEventListener("change", c), t == null || t.removeEventListener("change", c);
      };
    }
  }, [e, t]), typeof window.matchMedia != "function", r;
}, Yt = Ae(void 0);
function Hi() {
  return we(Yt);
}
function xi() {
  const e = /* @__PURE__ */ new Set();
  let t = {};
  return {
    /**
     * Subscribe to the editor instance's changes.
     */
    subscribe(n) {
      return e.add(n), () => {
        e.delete(n);
      };
    },
    getSnapshot() {
      return t;
    },
    getServerSnapshot() {
      return t;
    },
    /**
     * Adds a new NodeView Renderer to the editor.
     */
    setRenderer(n, o) {
      t = {
        ...t,
        [n]: ze(o.reactElement, o.element, n)
      }, e.forEach((r) => r());
    },
    /**
     * Removes a NodeView Renderer from the editor.
     */
    removeRenderer(n) {
      const o = { ...t };
      delete o[n], t = o, e.forEach((r) => r());
    }
  };
}
const yi = ({
  contentComponent: e
}) => {
  const t = Ze(
    e.subscribe,
    e.getSnapshot,
    e.getServerSnapshot
  );
  return /* @__PURE__ */ l(N, { children: Object.values(t) });
}, Si = dn((e, t) => {
  const [n, o] = M();
  return un(t, () => (r, i) => {
    yt(() => {
      o({ node: r, container: i });
    }), o(void 0);
  }, []), /* @__PURE__ */ l(N, { children: n && ze(n.node, n.container) });
}), gt = () => {
};
function Vi(e, t) {
  const {
    editor: n,
    className: o,
    theme: r,
    children: i,
    editable: c,
    onSelectionChange: s,
    onChange: a,
    formattingToolbar: d,
    linkToolbar: u,
    slashMenu: m,
    emojiPicker: f,
    sideMenu: h,
    filePanel: g,
    tableHandles: b,
    comments: p,
    autoFocus: x,
    renderEditor: I = !0,
    ...O
  } = e, [E, $] = M(), B = q(), P = ki(), K = (B == null ? void 0 : B.colorSchemePreference) || P, oe = r || (K === "dark" ? "dark" : "light");
  vi(a || gt, n), wi(s || gt, n), y(() => {
    n.isEditable = c !== !1;
  }, [c, n]);
  const z = k(
    (on) => {
      n.elementRenderer = on;
    },
    [n]
  ), ee = S(() => ({
    ...B,
    editor: n,
    setContentEditableProps: $,
    colorSchemePreference: oe
  }), [B, n, oe]), nn = S(() => ({
    editorProps: {
      autoFocus: x,
      contentEditableProps: E
    },
    defaultUIProps: {
      formattingToolbar: d,
      linkToolbar: u,
      slashMenu: m,
      emojiPicker: f,
      sideMenu: h,
      filePanel: g,
      tableHandles: b,
      comments: p
    }
  }), [
    x,
    E,
    d,
    u,
    m,
    f,
    h,
    g,
    b,
    p
  ]);
  return /* @__PURE__ */ l(Tt.Provider, { value: ee, children: /* @__PURE__ */ H(Yt.Provider, { value: nn, children: [
    /* @__PURE__ */ l(Si, { ref: z }),
    /* @__PURE__ */ l(
      Mi,
      {
        className: o,
        renderEditor: I,
        editable: c,
        editorColorScheme: oe,
        ref: t,
        ...O,
        children: i
      }
    )
  ] }) });
}
const Mi = D.forwardRef(
  ({ className: e, renderEditor: t, editable: n, editorColorScheme: o, children: r, ...i }, c) => /* @__PURE__ */ l(
    "div",
    {
      className: Z("bn-container", o, e),
      "data-color-scheme": o,
      ...i,
      ref: c,
      children: t ? /* @__PURE__ */ l(Ti, { editable: n, children: r }) : r
    }
  )
), Hl = D.forwardRef(Vi), Ti = (e) => {
  const t = Hi(), n = C(), o = S(() => xi(), []), r = k(
    (i) => {
      e.editable !== void 0 && e.editable !== n.isEditable && (n.isEditable = e.editable), n._tiptapEditor.contentComponent = o, i ? n.mount(i) : n.unmount();
    },
    [n, o, e.editable]
  );
  return /* @__PURE__ */ H(N, { children: [
    /* @__PURE__ */ l(yi, { contentComponent: o }),
    /* @__PURE__ */ l(_i, { ...t.editorProps, ...e, mount: r }),
    /* @__PURE__ */ l(Ci, { ...t.defaultUIProps }),
    e.children
  ] });
}, _i = (e) => {
  const { autoFocus: t, mount: n, contentEditableProps: o } = e;
  return /* @__PURE__ */ l(
    "div",
    {
      "aria-autocomplete": "list",
      "aria-haspopup": "listbox",
      "data-bn-autofocus": t,
      ref: n,
      ...o
    }
  );
};
function Y(e, t) {
  let n;
  const o = document.createElement("div");
  let r;
  if (t != null && t.elementRenderer)
    t.elementRenderer(
      e((a) => n = a || void 0),
      o
    );
  else {
    if (!(t != null && t.headless))
      throw new Error(
        "elementRenderer not available, expected headless editor"
      );
    r = ro(o), yt(() => {
      r.render(e((a) => n = a || void 0));
    });
  }
  if (!o.childElementCount)
    return console.warn("ReactInlineContentSpec: renderHTML() failed"), {
      dom: document.createElement("span")
    };
  n == null || n.setAttribute("data-tmp-find", "true");
  const i = o.cloneNode(!0), c = i.firstElementChild, s = i.querySelector(
    "[data-tmp-find]"
  );
  return s == null || s.removeAttribute("data-tmp-find"), r == null || r.unmount(), {
    dom: c,
    contentDOM: s || void 0
  };
}
function Le(e) {
  var t;
  return (
    // Creates `blockContent` element
    /* @__PURE__ */ l(
      Mt,
      {
        onDragOver: (n) => n.preventDefault(),
        ...Object.fromEntries(
          Object.entries(e.domAttributes || {}).filter(
            ([n]) => n !== "class"
          )
        ),
        className: Z(
          "bn-block-content",
          ((t = e.domAttributes) == null ? void 0 : t.class) || ""
        ),
        "data-content-type": e.blockType,
        ...Object.fromEntries(
          Object.entries(e.blockProps).filter(([n, o]) => {
            const r = e.propSchema[n];
            return o !== r.default;
          }).map(([n, o]) => [Ht(n), o])
        ),
        "data-file-block": e.isFileBlock === !0 || void 0,
        children: e.children
      }
    )
  );
}
function ye(e, t, n) {
  return (o = {}) => {
    const r = typeof e == "function" ? e(o) : e, i = typeof t == "function" ? t(o) : t, c = n ? typeof n == "function" ? n(o) : n : void 0;
    return {
      config: r,
      implementation: {
        ...i,
        toExternalHTML(s, a) {
          const d = i.toExternalHTML || i.render;
          return Y((m) => /* @__PURE__ */ l(
            Le,
            {
              blockType: s.type,
              blockProps: s.props,
              propSchema: r.propSchema,
              domAttributes: this.blockContentDOMAttributes,
              children: /* @__PURE__ */ l(
                d,
                {
                  block: s,
                  editor: a,
                  contentRef: (f) => {
                    m(f), f && (f.className = Z(
                      "bn-inline-content",
                      f.className
                    ));
                  }
                }
              )
            }
          ), a);
        },
        render(s, a) {
          if (this.renderType === "nodeView")
            return St(
              (d) => {
                var h;
                const u = _n(
                  d.getPos,
                  a,
                  d.editor,
                  r.type
                ), m = Vt().nodeViewContentRef;
                if (!m)
                  throw new Error("nodeViewContentRef is not set");
                const f = i.render;
                return /* @__PURE__ */ l(
                  Le,
                  {
                    blockType: u.type,
                    blockProps: u.props,
                    propSchema: r.propSchema,
                    isFileBlock: !!((h = i.meta) != null && h.fileBlockAccept),
                    domAttributes: this.blockContentDOMAttributes,
                    children: /* @__PURE__ */ l(
                      f,
                      {
                        block: u,
                        editor: a,
                        contentRef: (g) => {
                          m(g), g && (g.className = Z(
                            "bn-inline-content",
                            g.className
                          ), g.dataset.nodeViewContent = "");
                        }
                      }
                    )
                  }
                );
              },
              {
                className: "bn-react-node-view-renderer"
              }
            )(this.props);
          {
            const d = i.render;
            return Y((m) => /* @__PURE__ */ l(
              Le,
              {
                blockType: s.type,
                blockProps: s.props,
                propSchema: r.propSchema,
                domAttributes: this.blockContentDOMAttributes,
                children: /* @__PURE__ */ l(
                  d,
                  {
                    block: s,
                    editor: a,
                    contentRef: (f) => {
                      m(f), f && (f.className = Z(
                        "bn-inline-content",
                        f.className
                      ));
                    }
                  }
                )
              }
            ), a);
          }
        }
      },
      extensions: c
    };
  };
}
function We(e) {
  const t = C(), [n, o] = M("loading"), [r, i] = M();
  if (y(() => {
    let c = !0;
    return (async () => {
      let s = "";
      o("loading");
      try {
        s = t.resolveFileUrl ? await t.resolveFileUrl(e) : e;
      } catch {
        o("error");
        return;
      }
      c && (o("loaded"), i(s));
    })(), () => {
      c = !1;
    };
  }, [t, e]), n !== "loaded")
    return {
      loadingState: n
    };
  if (!r)
    throw new Error("Finished fetching file but did not get download URL.");
  return {
    loadingState: n,
    downloadUrl: r
  };
}
const qe = (e) => /* @__PURE__ */ H("figure", { children: [
  e.children,
  /* @__PURE__ */ l("figcaption", { children: e.caption })
] });
function Bi(e) {
  const t = C();
  y(() => t.onUploadEnd(e), [e, t]);
}
function Ei(e) {
  const t = C();
  y(() => t.onUploadStart(e), [e, t]);
}
function Jt(e) {
  const [t, n] = M(!1);
  return Ei((o) => {
    o === e && n(!0);
  }), Bi((o) => {
    o === e && n(!1);
  }), t;
}
const Li = (e) => {
  const t = C(), n = V(), o = T(he), r = k(
    (c) => {
      c.preventDefault();
    },
    []
  ), i = k(() => {
    t.isEditable && e.editor.transact(() => o.showMenu(e.block.id));
  }, [t.isEditable, o, e.block.id, e.editor]);
  return /* @__PURE__ */ H(
    "div",
    {
      className: "bn-add-file-button",
      onMouseDown: r,
      onClick: i,
      children: [
        /* @__PURE__ */ l("div", { className: "bn-add-file-button-icon", children: e.buttonIcon || /* @__PURE__ */ l(je, { size: 24 }) }),
        /* @__PURE__ */ l("div", { className: "bn-add-file-button-text", children: e.block.type in n.file_blocks.add_button_text ? n.file_blocks.add_button_text[e.block.type] : n.file_blocks.add_button_text.file })
      ]
    }
  );
}, Ri = (e) => /* @__PURE__ */ H(
  "div",
  {
    className: "bn-file-name-with-icon",
    contentEditable: !1,
    draggable: !1,
    children: [
      /* @__PURE__ */ l("div", { className: "bn-file-icon", children: /* @__PURE__ */ l(je, { size: 24 }) }),
      /* @__PURE__ */ l("p", { className: "bn-file-name", children: e.block.props.name })
    ]
  }
), Ke = (e) => {
  const t = Jt(e.block.id);
  return /* @__PURE__ */ l(
    "div",
    {
      className: "bn-file-block-content-wrapper",
      onMouseEnter: e.onMouseEnter,
      onMouseLeave: e.onMouseLeave,
      style: e.style,
      children: t ? (
        // Show loader while a file is being uploaded.
        /* @__PURE__ */ l("div", { className: "bn-file-loading-preview", children: "Loading..." })
      ) : e.block.props.url === "" ? (
        // Show the add file button if the file has not been uploaded yet.
        /* @__PURE__ */ l(Li, { ...e })
      ) : (
        // Show the file preview, or the file name and icon.
        /* @__PURE__ */ H(N, { children: [
          e.block.props.showPreview === !1 || !e.children ? (
            // Show file name and icon.
            /* @__PURE__ */ l(Ri, { ...e })
          ) : (
            // Show preview.
            e.children
          ),
          e.block.props.caption && // Show the caption if there is one.
          /* @__PURE__ */ l("p", { className: "bn-file-caption", children: e.block.props.caption })
        ] })
      )
    }
  );
}, Se = (e) => /* @__PURE__ */ H("div", { children: [
  e.children,
  /* @__PURE__ */ l("p", { children: e.caption })
] }), Oi = (e) => {
  const t = We(e.block.props.url);
  return /* @__PURE__ */ l(
    "audio",
    {
      className: "bn-audio",
      src: t.loadingState === "loading" ? e.block.props.url : t.downloadUrl,
      controls: !0,
      contentEditable: !1,
      draggable: !1
    }
  );
}, Ii = (e) => {
  if (!e.block.props.url)
    return /* @__PURE__ */ l("p", { children: "Add audio" });
  const t = e.block.props.showPreview ? /* @__PURE__ */ l("audio", { src: e.block.props.url }) : /* @__PURE__ */ l("a", { href: e.block.props.url, children: e.block.props.name || e.block.props.url });
  return e.block.props.caption ? e.block.props.showPreview ? /* @__PURE__ */ l(qe, { caption: e.block.props.caption, children: t }) : /* @__PURE__ */ l(Se, { caption: e.block.props.caption, children: t }) : t;
}, Pi = (e) => /* @__PURE__ */ l(
  Ke,
  {
    ...e,
    buttonIcon: /* @__PURE__ */ l(jt, { size: 24 }),
    children: /* @__PURE__ */ l(Oi, { ...e })
  }
), xl = ye(
  En,
  (e) => ({
    render: Pi,
    parse: Bn(e),
    toExternalHTML: Ii,
    runsBefore: ["file"]
  })
), yl = ye(Rn, {
  render: (e) => /* @__PURE__ */ l(Ke, { ...e }),
  parse: Ln(),
  toExternalHTML: (e) => {
    if (!e.block.props.url)
      return /* @__PURE__ */ l("p", { children: "Add file" });
    const t = /* @__PURE__ */ l("a", { href: e.block.props.url, children: e.block.props.name || e.block.props.url });
    return e.block.props.caption ? /* @__PURE__ */ l(Se, { caption: e.block.props.caption, children: t }) : t;
  }
}), Qt = (e) => {
  const [t, n] = M(void 0), [o, r] = M(
    e.block.props.previewWidth
  ), [i, c] = M(!1), s = F(null);
  y(() => {
    const h = (b) => {
      var O, E;
      let p;
      const x = "touches" in b ? b.touches[0].clientX : b.clientX;
      e.block.props.textAlignment === "center" ? t.handleUsed === "left" ? p = t.initialWidth + (t.initialClientX - x) * 2 : p = t.initialWidth + (x - t.initialClientX) * 2 : t.handleUsed === "left" ? p = t.initialWidth + t.initialClientX - x : p = t.initialWidth + x - t.initialClientX, r(
        Math.min(
          Math.max(p, 64),
          ((E = (O = e.editor.domElement) == null ? void 0 : O.firstElementChild) == null ? void 0 : E.clientWidth) || Number.MAX_VALUE
        )
      );
    }, g = () => {
      n(void 0), e.editor.updateBlock(e.block, {
        props: {
          previewWidth: o
        }
      });
    };
    return t && (window.addEventListener("mousemove", h), window.addEventListener("touchmove", h), window.addEventListener("mouseup", g), window.addEventListener("touchend", g)), () => {
      window.removeEventListener("mousemove", h), window.removeEventListener("touchmove", h), window.removeEventListener("mouseup", g), window.removeEventListener("touchend", g);
    };
  }, [e, t, o]);
  const a = k(() => {
    e.editor.isEditable && c(!0);
  }, [e.editor.isEditable]), d = k(() => {
    c(!1);
  }, []), u = k(
    (h) => {
      h.preventDefault();
      const g = "touches" in h ? h.touches[0].clientX : h.clientX;
      n({
        handleUsed: "left",
        initialWidth: s.current.clientWidth,
        initialClientX: g
      });
    },
    []
  ), m = k(
    (h) => {
      h.preventDefault();
      const g = "touches" in h ? h.touches[0].clientX : h.clientX;
      n({
        handleUsed: "right",
        initialWidth: s.current.clientWidth,
        initialClientX: g
      });
    },
    []
  ), f = Jt(e.block.id);
  return /* @__PURE__ */ l(
    Ke,
    {
      ...e,
      onMouseEnter: a,
      onMouseLeave: d,
      style: e.block.props.url && !f && e.block.props.showPreview ? {
        width: o ? `${o}px` : "fit-content"
      } : void 0,
      children: /* @__PURE__ */ H(
        "div",
        {
          className: "bn-visual-media-wrapper",
          style: { position: "relative" },
          ref: s,
          children: [
            e.children,
            (i || t) && /* @__PURE__ */ H(N, { children: [
              /* @__PURE__ */ l(
                "div",
                {
                  className: "bn-resize-handle",
                  style: { left: "4px" },
                  onMouseDown: u,
                  onTouchStart: u
                }
              ),
              /* @__PURE__ */ l(
                "div",
                {
                  className: "bn-resize-handle",
                  style: { right: "4px" },
                  onMouseDown: m,
                  onTouchStart: m
                }
              )
            ] }),
            t && /* @__PURE__ */ l(
              "div",
              {
                style: {
                  position: "absolute",
                  height: "100%",
                  width: "100%"
                }
              }
            )
          ]
        }
      )
    }
  );
}, Ni = (e) => {
  const t = We(e.block.props.url);
  return /* @__PURE__ */ l(
    "img",
    {
      className: "bn-visual-media",
      src: t.loadingState === "loading" ? e.block.props.url : t.downloadUrl,
      alt: e.block.props.caption || "BlockNote image",
      contentEditable: !1,
      draggable: !1
    }
  );
}, Ai = (e) => {
  if (!e.block.props.url)
    return /* @__PURE__ */ l("p", { children: "Add image" });
  const t = e.block.props.showPreview ? /* @__PURE__ */ l(
    "img",
    {
      src: e.block.props.url,
      alt: e.block.props.name || e.block.props.caption || "BlockNote image",
      width: e.block.props.previewWidth
    }
  ) : /* @__PURE__ */ l("a", { href: e.block.props.url, children: e.block.props.name || e.block.props.url });
  return e.block.props.caption ? e.block.props.showPreview ? /* @__PURE__ */ l(qe, { caption: e.block.props.caption, children: t }) : /* @__PURE__ */ l(Se, { caption: e.block.props.caption, children: t }) : t;
}, Zi = (e) => /* @__PURE__ */ l(
  Qt,
  {
    ...e,
    buttonIcon: /* @__PURE__ */ l(zt, { size: 24 }),
    children: /* @__PURE__ */ l(Ni, { ...e })
  }
), Sl = ye(
  In,
  (e) => ({
    render: Zi,
    parse: On(e),
    toExternalHTML: Ai
  })
);
function Di(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M14 3v4a1 1 0 0 0 1 1h4" }, child: [] }, { tag: "path", attr: { d: "M19 18v1a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-1" }, child: [] }, { tag: "path", attr: { d: "M3 14h3m4.5 0h3m4.5 0h3" }, child: [] }, { tag: "path", attr: { d: "M5 10v-5a2 2 0 0 1 2 -2h7l5 5v2" }, child: [] }] })(e);
}
const Fi = {
  page_break: Di
};
function Vl(e) {
  return Pn(e).map((t) => {
    const n = Fi[t.key];
    return {
      ...t,
      icon: /* @__PURE__ */ l(n, { size: 18 })
    };
  });
}
const Gi = (e) => {
  const t = We(e.block.props.url);
  return /* @__PURE__ */ l(
    "video",
    {
      className: "bn-visual-media",
      src: t.loadingState === "loading" ? e.block.props.url : t.downloadUrl,
      controls: !0,
      contentEditable: !1,
      draggable: !1
    }
  );
}, zi = (e) => {
  if (!e.block.props.url)
    return /* @__PURE__ */ l("p", { children: "Add video" });
  const t = e.block.props.showPreview ? /* @__PURE__ */ l("video", { src: e.block.props.url }) : /* @__PURE__ */ l("a", { href: e.block.props.url, children: e.block.props.name || e.block.props.url });
  return e.block.props.caption ? e.block.props.showPreview ? /* @__PURE__ */ l(qe, { caption: e.block.props.caption, children: t }) : /* @__PURE__ */ l(Se, { caption: e.block.props.caption, children: t }) : t;
}, Ui = (e) => /* @__PURE__ */ l(
  Qt,
  {
    ...e,
    buttonIcon: /* @__PURE__ */ l(Ko, { size: 24 }),
    children: /* @__PURE__ */ l(Gi, { ...e })
  }
), Ml = ye(
  An,
  (e) => ({
    render: Ui,
    parse: Nn(e),
    toExternalHTML: zi
  })
), ji = (e, t) => {
  if (t.type === "toggled")
    return !e;
  if (t.type === "childAdded")
    return !0;
  if (t.type === "lastChildRemoved")
    return !1;
  throw new xt(t);
}, Tl = (e) => {
  const { block: t, editor: n, children: o, toggledState: r } = e, [i, c] = mn(
    ji,
    (r || ae).get(t)
  ), s = (m) => {
    (r || ae).set(
      n.getBlock(m),
      !i
    ), c({
      type: "toggled"
    });
  }, a = (m) => {
    (r || ae).set(m, !0), c({
      type: "childAdded"
    });
  }, d = (m) => {
    (r || ae).set(m, !1), c({
      type: "lastChildRemoved"
    });
  }, u = R({
    editor: n,
    selector: ({ editor: m }) => {
      if (!A(t, m, t.type, { isToggleable: "boolean" }) && !t.props.isToggleable)
        return 0;
      const f = m.getBlock(t), h = f.children.length || 0;
      return h > u ? i || a(f) : h === 0 && h < u && i && d(f), h;
    }
  });
  return "isToggleable" in t.props && !t.props.isToggleable ? o : /* @__PURE__ */ H("div", { children: [
    /* @__PURE__ */ H("div", { className: "bn-toggle-wrapper", "data-show-children": i, children: [
      /* @__PURE__ */ l(
        "button",
        {
          className: "bn-toggle-button",
          type: "button",
          onMouseDown: (m) => m.preventDefault(),
          onClick: () => s(n.getBlock(t)),
          children: /* @__PURE__ */ l(
            "svg",
            {
              xmlns: "http://www.w3.org/2000/svg",
              height: "1em",
              viewBox: "0 -960 960 960",
              width: "1em",
              fill: "currentcolor",
              children: /* @__PURE__ */ l("path", { d: "M472-480 332-620q-18-18-18-44t18-44q18-18 44-18t44 18l183 183q9 9 14 21t5 24q0 12-5 24t-14 21L420-252q-18 18-44 18t-44-18q-18-18-18-44t18-44l140-140Z" })
            }
          )
        }
      ),
      o
    ] }),
    n.isEditable && i && u === 0 && /* @__PURE__ */ l(
      "button",
      {
        className: "bn-toggle-add-block-button",
        type: "button",
        onClick: () => {
          const m = n.updateBlock(t, {
            // Single empty block with default type.
            children: [{}]
          });
          n.setTextCursorPosition(m.children[0].id, "end"), n.focus();
        },
        children: n.dictionary.toggle_blocks.add_block_button
      }
    )
  ] });
}, _l = (e) => {
  const [t, n] = M("none"), o = F(null), r = C(), i = _(ne, {
    editor: r
  }), c = S(() => ({
    display: "flex",
    position: "fixed",
    bottom: 0,
    zIndex: "calc(var(--bn-ui-base-z-index) + 40)",
    transform: t
  }), [t]);
  if (y(() => {
    const a = window.visualViewport;
    function d() {
      const u = document.body, m = a.offsetLeft, f = a.height - u.getBoundingClientRect().height + a.offsetTop;
      n(
        `translate(${m}px, ${f}px) scale(${1 / a.scale})`
      );
    }
    return window.visualViewport.addEventListener("scroll", d), window.visualViewport.addEventListener("resize", d), d(), () => {
      window.visualViewport.removeEventListener("scroll", d), window.visualViewport.removeEventListener("resize", d);
    };
  }, []), !i && o.current)
    return /* @__PURE__ */ l(
      "div",
      {
        ref: o,
        style: c,
        dangerouslySetInnerHTML: { __html: o.current.innerHTML }
      }
    );
  const s = e.formattingToolbar || Wt;
  return /* @__PURE__ */ l("div", { ref: o, style: c, children: /* @__PURE__ */ l(s, {}) });
}, Bl = (e) => {
  const { blockId: t, colIndex: n, rowIndex: o, children: r, ...i } = e, c = C(), s = S(() => {
    if (t === void 0 || n === void 0 || o === void 0)
      return;
    const a = Ge(t, c.prosemirrorState.doc);
    if (!a)
      return;
    const d = a.posBeforeNode + 1, u = c.prosemirrorState.doc.resolve(d + 1).posAtIndex(o || 0), m = c.prosemirrorState.doc.resolve(u + 1).posAtIndex(n || 0), { node: f } = c.prosemirrorView.domAtPos(m + 1);
    if (f instanceof Element)
      return f;
  }, [c, t, n, o]);
  return /* @__PURE__ */ l(U, { reference: s, ...i, children: r });
};
function bt(e, t, n) {
  const { refs: o, update: r, context: i, floatingStyles: c } = De({
    open: t,
    placement: e === "addOrRemoveColumns" ? "right" : "bottom",
    middleware: [
      re({
        apply({ rects: d, elements: u }) {
          Object.assign(
            u.floating.style,
            e === "addOrRemoveColumns" ? {
              height: `${d.reference.height}px`
            } : {
              width: `${d.reference.width}px`
            }
          );
        }
      })
    ]
  }), { isMounted: s, styles: a } = Fe(i);
  return y(() => {
    r();
  }, [n, r]), y(() => {
    n !== null && o.setReference({
      getBoundingClientRect: () => n
    });
  }, [e, n, o]), S(
    () => ({
      isMounted: s,
      ref: o.setFloating,
      style: {
        display: "flex",
        ...a,
        ...c
      }
    }),
    [c, s, o.setFloating, a]
  );
}
function El(e, t, n) {
  const o = bt(
    "addOrRemoveRows",
    t,
    n
  ), r = bt(
    "addOrRemoveColumns",
    e,
    n
  );
  return S(
    () => ({
      addOrRemoveRowsButton: o,
      addOrRemoveColumnsButton: r
    }),
    [r, o]
  );
}
function $i(e, t, n) {
  return n && n.draggedCellOrientation === "row" ? new DOMRect(
    t.x,
    n.mousePos,
    t.width,
    0
  ) : new DOMRect(
    t.x,
    e.y,
    t.width,
    e.height
  );
}
function Wi(e, t, n) {
  return n && n.draggedCellOrientation === "col" ? new DOMRect(
    n.mousePos,
    t.y,
    0,
    t.height
  ) : new DOMRect(
    e.x,
    t.y,
    e.width,
    t.height
  );
}
function qi(e) {
  return new DOMRect(
    e.x,
    e.y,
    e.width,
    0
  );
}
function Re(e, t, n, o, r) {
  const { refs: i, update: c, context: s, floatingStyles: a } = De({
    open: t,
    placement: e === "row" ? "left" : e === "col" ? "top" : "bottom-end",
    middleware: [
      j(
        e === "row" ? -10 : e === "col" ? -12 : { mainAxis: 1, crossAxis: -1 }
      )
    ]
  }), { isMounted: d, styles: u } = Fe(s);
  return y(() => {
    c();
  }, [n, o, c]), y(() => {
    n === null || o === null || // Ignore cell handle when dragging
    r && e === "cell" || i.setReference({
      getBoundingClientRect: () => (e === "row" ? $i : e === "col" ? Wi : qi)(n, o, r)
    });
  }, [r, e, n, o, i]), S(
    () => ({
      isMounted: d,
      ref: i.setFloating,
      style: {
        display: "flex",
        ...u,
        ...a
      }
    }),
    [a, d, i.setFloating, u]
  );
}
function Ll(e, t, n, o) {
  const r = Re(
    "row",
    e,
    t,
    n,
    o
  ), i = Re(
    "col",
    e,
    t,
    n,
    o
  ), c = Re(
    "cell",
    e,
    t,
    n,
    o
  );
  return S(
    () => ({
      rowHandle: r,
      colHandle: i,
      cellHandle: c
    }),
    [i, r, c]
  );
}
const Xe = (e = {}, t = []) => S(() => {
  const n = Zn.create(e);
  return window && (window.ProseMirror = n._tiptapEditor), n;
}, t), Ye = (e) => {
  const [t, n] = M(!1), o = R({
    editor: e.editor,
    selector: ({ editor: s }) => s.isEmpty
  }), r = v(), i = k(() => {
    n(!0);
  }, []), c = k(() => {
    n(!1);
  }, []);
  return y(() => {
    e.editable && e.autoFocus && e.editor.focus();
  }, [e.autoFocus, e.editable, e.editor]), /* @__PURE__ */ H(N, { children: [
    /* @__PURE__ */ l(
      r.Comments.Editor,
      {
        autoFocus: e.autoFocus,
        className: "bn-comment-editor",
        editor: e.editor,
        onFocus: i,
        onBlur: c,
        editable: e.editable
      }
    ),
    e.actions && /* @__PURE__ */ l("div", { className: "bn-comment-actions-wrapper", children: /* @__PURE__ */ l(e.actions, { isFocused: t, isEmpty: o }) })
  ] });
};
let me;
async function Ki() {
  return me || (me = (async () => {
    const [e, t] = await Promise.all([
      import("emoji-mart"),
      // use a dynamic import to encourage bundle-splitting
      // and a smaller initial client bundle size
      import("@emoji-mart/data")
    ]), n = "default" in e ? e.default : e, o = "default" in t ? t.default : t;
    return await n.init({ data: o }), { emojiMart: n, emojiData: o };
  })(), me);
}
function Xi(e) {
  const t = F(null), n = F(null);
  return n.current && n.current.update(e), y(() => ((async () => {
    const { emojiMart: o } = await Ki();
    n.current = new o.Picker({ ...e, ref: t });
  })(), () => {
    n.current = null;
  }), []), D.createElement("div", { ref: t });
}
const pt = (e) => {
  const [t, n] = M(!1), o = v(), r = C(), i = q();
  return /* @__PURE__ */ H(o.Generic.Popover.Root, { open: t, children: [
    /* @__PURE__ */ l(o.Generic.Popover.Trigger, { children: /* @__PURE__ */ l(
      "div",
      {
        onClick: (c) => {
          var s;
          c.preventDefault(), c.stopPropagation(), n(!t), (s = e.onOpenChange) == null || s.call(e, !t);
        },
        style: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        },
        children: e.children
      }
    ) }),
    ze(
      /* @__PURE__ */ l(
        o.Generic.Popover.Content,
        {
          className: "bn-emoji-picker-popover",
          variant: "panel-popover",
          children: /* @__PURE__ */ l(
            Xi,
            {
              perLine: 7,
              onClickOutside: () => {
                var c;
                n(!1), (c = e.onOpenChange) == null || c.call(e, !1);
              },
              onEmojiSelect: (c) => {
                var s;
                e.onEmojiSelect(c), n(!1), (s = e.onOpenChange) == null || s.call(e, !1);
              },
              theme: i == null ? void 0 : i.colorSchemePreference
            }
          )
        }
      ),
      r.domElement.parentElement
    )
  ] });
};
function Yi(e) {
  return Je([e]).get(e);
}
function Je(e) {
  const n = T(G).userStore, o = k(() => {
    const c = /* @__PURE__ */ new Map();
    for (const s of e) {
      const a = n.getUser(s);
      a && c.set(s, a);
    }
    return c;
  }, [n, e]), r = S(() => ({
    current: o()
  }), [o]), i = k(
    (c) => {
      const s = n.subscribe((a) => {
        r.current = o(), c();
      });
      return n.loadUsers(e), s;
    },
    [n, o, e, r]
  );
  return Ze(i, () => r.current);
}
const Ji = (e) => {
  const t = v(), n = V(), o = T(G), r = e.comment.reactions.find(
    (a) => a.emoji === e.emoji
  );
  if (!r)
    throw new Error(
      "Trying to render reaction badge for non-existing reaction"
    );
  const [i, c] = M([]), s = Je(i);
  return /* @__PURE__ */ l(
    t.Generic.Badge.Root,
    {
      className: Z("bn-badge", "bn-comment-reaction"),
      text: r.userIds.length.toString(),
      icon: r.emoji,
      isSelected: o.threadStore.auth.canDeleteReaction(
        e.comment,
        r.emoji
      ),
      onClick: () => e.onReactionSelect(r.emoji),
      onMouseEnter: () => c(r.userIds),
      mainTooltip: n.comments.reactions.reacted_by,
      secondaryTooltip: `${Array.from(s.values()).map((a) => a.username).join(`
`)}`
    },
    r.emoji
  );
}, { textColor: Rl, backgroundColor: Ol, ...Qi } = Fn, Qe = Dn.create({
  blockSpecs: {
    paragraph: Gn()
  },
  styleSpecs: Qi
}), el = ({
  comment: e,
  thread: t,
  showResolveButton: n
}) => {
  const o = T(G), r = V(), i = Xe({
    initialContent: e.body,
    trailingBlock: !1,
    dictionary: {
      ...r,
      placeholders: {
        emptyDocument: r.placeholders.edit_comment
      }
    },
    schema: o.commentEditorSchema || Qe
  }), c = v(), [s, a] = M(!1), [d, u] = M(!1), m = o.threadStore, f = k(() => {
    a(!0);
  }, []), h = k(() => {
    i.replaceBlocks(i.document, e.body), a(!1);
  }, [i, e.body]), g = k(
    async (z) => {
      await m.updateComment({
        commentId: e.id,
        comment: {
          body: i.document
        },
        threadId: t.id
      }), a(!1);
    },
    [e, t.id, i, m]
  ), b = k(async () => {
    await m.deleteComment({
      commentId: e.id,
      threadId: t.id
    });
  }, [e, t.id, m]), p = k(
    async (z) => {
      m.auth.canAddReaction(e, z) ? await m.addReaction({
        threadId: t.id,
        commentId: e.id,
        emoji: z
      }) : m.auth.canDeleteReaction(e, z) && await m.deleteReaction({
        threadId: t.id,
        commentId: e.id,
        emoji: z
      });
    },
    [m, e, t.id]
  ), x = k(async () => {
    await m.resolveThread({
      threadId: t.id
    });
  }, [t.id, m]), I = k(async () => {
    await m.unresolveThread({
      threadId: t.id
    });
  }, [t.id, m]), O = Yi(e.userId);
  if (!e.body)
    return null;
  let E;
  const $ = m.auth.canAddReaction(e), B = m.auth.canDeleteComment(e), P = m.auth.canUpdateComment(e), K = n && (t.resolved ? m.auth.canUnresolveThread(t) : m.auth.canResolveThread(t));
  s || (E = /* @__PURE__ */ H(
    c.Generic.Toolbar.Root,
    {
      className: Z("bn-action-toolbar", "bn-comment-actions"),
      variant: "action-toolbar",
      children: [
        $ && /* @__PURE__ */ l(
          pt,
          {
            onEmojiSelect: (z) => p(z.native),
            onOpenChange: u,
            children: /* @__PURE__ */ l(
              c.Generic.Toolbar.Button,
              {
                mainTooltip: r.comments.actions.add_reaction,
                variant: "compact",
                children: /* @__PURE__ */ l(ut, { size: 16 })
              },
              "add-reaction"
            )
          }
        ),
        K && (t.resolved ? /* @__PURE__ */ l(
          c.Generic.Toolbar.Button,
          {
            mainTooltip: "Re-open",
            variant: "compact",
            onClick: I,
            children: /* @__PURE__ */ l(To, { size: 16 })
          },
          "reopen"
        ) : /* @__PURE__ */ l(
          c.Generic.Toolbar.Button,
          {
            mainTooltip: r.comments.actions.resolve,
            variant: "compact",
            onClick: x,
            children: /* @__PURE__ */ l(Yo, { size: 16 })
          },
          "resolve"
        )),
        (B || P) && /* @__PURE__ */ H(c.Generic.Menu.Root, { position: "bottom-start", children: [
          /* @__PURE__ */ l(c.Generic.Menu.Trigger, { children: /* @__PURE__ */ l(
            c.Generic.Toolbar.Button,
            {
              mainTooltip: r.comments.actions.more_actions,
              variant: "compact",
              children: /* @__PURE__ */ l(nr, { size: 16 })
            },
            "more-actions"
          ) }),
          /* @__PURE__ */ H(c.Generic.Menu.Dropdown, { className: "bn-menu-dropdown", children: [
            P && /* @__PURE__ */ l(
              c.Generic.Menu.Item,
              {
                icon: /* @__PURE__ */ l(_o, {}),
                onClick: f,
                children: r.comments.actions.edit_comment
              },
              "edit-comment"
            ),
            B && /* @__PURE__ */ l(
              c.Generic.Menu.Item,
              {
                icon: /* @__PURE__ */ l(Qo, {}),
                onClick: b,
                children: r.comments.actions.delete_comment
              },
              "delete-comment"
            )
          ] })
        ] })
      ]
    }
  ));
  const oe = e.createdAt.toLocaleDateString(void 0, {
    month: "short",
    day: "numeric"
  });
  if (!e.body)
    throw new Error("soft deletes are not yet supported");
  return /* @__PURE__ */ l(
    c.Comments.Comment,
    {
      authorInfo: O ?? "loading",
      timeString: oe,
      edited: e.updatedAt.getTime() !== e.createdAt.getTime(),
      showActions: "hover",
      actions: E,
      className: "bn-thread-comment",
      emojiPickerOpen: d,
      children: /* @__PURE__ */ l(
        Ye,
        {
          autoFocus: s,
          editor: i,
          editable: s,
          actions: e.reactions.length > 0 || s ? ({ isEmpty: z }) => /* @__PURE__ */ H(N, { children: [
            e.reactions.length > 0 && !s && /* @__PURE__ */ H(
              c.Generic.Badge.Group,
              {
                className: Z(
                  "bn-badge-group",
                  "bn-comment-reactions"
                ),
                children: [
                  e.reactions.map((ee) => /* @__PURE__ */ l(
                    Ji,
                    {
                      comment: e,
                      emoji: ee.emoji,
                      onReactionSelect: p
                    },
                    ee.emoji
                  )),
                  $ && /* @__PURE__ */ l(
                    pt,
                    {
                      onEmojiSelect: (ee) => p(ee.native),
                      onOpenChange: u,
                      children: /* @__PURE__ */ l(
                        c.Generic.Badge.Root,
                        {
                          className: Z(
                            "bn-badge",
                            "bn-comment-add-reaction"
                          ),
                          text: "+",
                          icon: /* @__PURE__ */ l(ut, { size: 16 }),
                          mainTooltip: r.comments.actions.add_reaction
                        }
                      )
                    }
                  )
                ]
              }
            ),
            s && /* @__PURE__ */ H(
              c.Generic.Toolbar.Root,
              {
                variant: "action-toolbar",
                className: Z(
                  "bn-action-toolbar",
                  "bn-comment-actions"
                ),
                children: [
                  /* @__PURE__ */ l(
                    c.Generic.Toolbar.Button,
                    {
                      mainTooltip: r.comments.save_button_text,
                      variant: "compact",
                      onClick: g,
                      isDisabled: z,
                      children: r.comments.save_button_text
                    }
                  ),
                  /* @__PURE__ */ l(
                    c.Generic.Toolbar.Button,
                    {
                      className: "bn-button",
                      mainTooltip: r.comments.cancel_button_text,
                      variant: "compact",
                      onClick: h,
                      children: r.comments.cancel_button_text
                    }
                  )
                ]
              }
            )
          ] }) : void 0
        }
      )
    }
  );
}, tl = ({
  thread: e,
  maxCommentsBeforeCollapse: t
}) => {
  const n = v(), o = V(), r = Je(e.resolvedBy ? [e.resolvedBy] : []), i = e.comments.map((c, s) => /* @__PURE__ */ l(
    el,
    {
      thread: e,
      comment: c,
      showResolveButton: s === 0
    },
    c.id + JSON.stringify(c.body || "{}")
  ));
  if (e.resolved && e.resolvedUpdatedAt && e.resolvedBy) {
    if (!r.get(e.resolvedBy))
      throw new Error(
        `User ${e.resolvedBy} resolved thread ${e.id}, but their data could not be found.`
      );
    const s = e.comments.findLastIndex(
      (a) => e.resolvedUpdatedAt.getTime() > a.createdAt.getTime()
    ) + 1;
    i.splice(
      s,
      0,
      /* @__PURE__ */ l(
        n.Comments.Comment,
        {
          className: "bn-thread-comment",
          authorInfo: e.resolvedBy && r.get(e.resolvedBy) || "loading",
          timeString: e.resolvedUpdatedAt.toLocaleDateString(void 0, {
            month: "short",
            day: "numeric"
          }),
          edited: !1,
          showActions: !1,
          children: /* @__PURE__ */ l("div", { className: "bn-resolved-text", children: o.comments.sidebar.marked_as_resolved })
        },
        "resolved-comment"
      )
    );
  }
  return t && i.length > t && i.splice(
    1,
    i.length - 2,
    /* @__PURE__ */ l(
      n.Comments.ExpandSectionsPrompt,
      {
        className: "bn-thread-expand-prompt",
        children: o.comments.sidebar.more_replies(e.comments.length - 2)
      },
      "expand-prompt"
    )
  ), i;
};
function nl() {
  const e = T(G), t = v(), n = V(), o = Xe({
    trailingBlock: !1,
    dictionary: {
      ...n,
      placeholders: {
        emptyDocument: n.placeholders.new_comment
      }
    },
    schema: e.commentEditorSchema || Qe
  });
  return /* @__PURE__ */ l(t.Comments.Card, { className: "bn-thread", children: /* @__PURE__ */ l(
    Ye,
    {
      autoFocus: !0,
      editable: !0,
      editor: o,
      actions: ({ isEmpty: r }) => /* @__PURE__ */ l(
        t.Generic.Toolbar.Root,
        {
          className: Z(
            "bn-action-toolbar",
            "bn-comment-actions"
          ),
          variant: "action-toolbar",
          children: /* @__PURE__ */ l(
            t.Generic.Toolbar.Button,
            {
              className: "bn-button",
              mainTooltip: "Save",
              variant: "compact",
              isDisabled: r,
              onClick: async () => {
                await e.createThread({
                  initialComment: {
                    body: o.document
                  }
                }), e.stopPendingComment();
              },
              children: "Save"
            }
          )
        }
      )
    }
  ) });
}
function ol(e) {
  const [t, n] = M(!1), o = C(), r = T(G), i = _(G, {
    editor: o,
    selector: (d) => d.pendingComment
  });
  y(() => {
    n(i);
  }, [i]);
  const c = R({
    editor: o,
    selector: ({ editor: d }) => i ? {
      from: d.prosemirrorState.selection.from,
      to: d.prosemirrorState.selection.to
    } : void 0
  }), s = S(
    () => ({
      useFloatingOptions: {
        open: t,
        // Needed as hooks like `useDismiss` call `onOpenChange` to change the
        // open state.
        onOpenChange: (d) => {
          d || (r.stopPendingComment(), o.focus()), n(d);
        },
        placement: "bottom",
        middleware: [j(10), ce(), Q()]
      },
      elementProps: {
        style: {
          zIndex: 60
        }
      },
      ...e.floatingUIOptions
    }),
    [r, o, t, e.floatingUIOptions]
  ), a = e.floatingComposer || nl;
  return /* @__PURE__ */ l(Ue, { position: c, ...s, children: /* @__PURE__ */ l(a, {}) });
}
const rl = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ol
}, Symbol.toStringTag, { value: "Module" })), en = ({
  thread: e,
  selected: t,
  referenceText: n,
  maxCommentsBeforeCollapse: o,
  onFocus: r,
  onBlur: i,
  tabIndex: c
}) => {
  const s = v(), a = V(), d = T(G), u = Xe({
    trailingBlock: !1,
    dictionary: {
      ...a,
      placeholders: {
        emptyDocument: a.placeholders.comment_reply
      }
    },
    schema: d.commentEditorSchema || Qe
  }), m = k(async () => {
    await d.threadStore.addComment({
      comment: {
        body: u.document
      },
      threadId: e.id
    }), u.removeBlocks(u.document);
  }, [d, u, e.id]);
  return /* @__PURE__ */ H(
    s.Comments.Card,
    {
      className: "bn-thread",
      headerText: n,
      onFocus: r,
      onBlur: i,
      selected: t,
      tabIndex: c,
      children: [
        /* @__PURE__ */ l(s.Comments.CardSection, { className: "bn-thread-comments", children: /* @__PURE__ */ l(
          tl,
          {
            thread: e,
            maxCommentsBeforeCollapse: t ? void 0 : o || 5
          }
        ) }),
        t && /* @__PURE__ */ l(s.Comments.CardSection, { className: "bn-thread-composer", children: /* @__PURE__ */ l(
          Ye,
          {
            autoFocus: !1,
            editable: !0,
            editor: u,
            actions: ({ isEmpty: f }) => f ? null : /* @__PURE__ */ l(
              s.Generic.Toolbar.Root,
              {
                variant: "action-toolbar",
                className: Z(
                  "bn-action-toolbar",
                  "bn-comment-actions"
                ),
                children: /* @__PURE__ */ l(
                  s.Generic.Toolbar.Button,
                  {
                    mainTooltip: a.comments.save_button_text,
                    variant: "compact",
                    isDisabled: f,
                    onClick: m,
                    children: a.comments.save_button_text
                  }
                )
              }
            )
          }
        ) })
      ]
    }
  );
};
function tn() {
  const t = T(G).threadStore, n = F(void 0);
  n.current || (n.current = t.getThreads());
  const o = k(
    (r) => t.subscribe((i) => {
      n.current = i, r();
    }),
    [t]
  );
  return Ze(o, () => n.current);
}
function il(e) {
  const t = C(), [n, o] = M(!1), r = T(G), i = _(G, {
    editor: t,
    selector: (u) => u.selectedThreadId ? {
      id: u.selectedThreadId,
      position: u.threadPositions.get(u.selectedThreadId)
    } : void 0
  });
  y(() => {
    o(!!i);
  }, [i]);
  const c = tn(), s = S(
    () => i ? c.get(i.id) : void 0,
    [i, c]
  ), a = S(
    () => ({
      useFloatingOptions: {
        open: n,
        // Needed as hooks like `useDismiss` call `onOpenChange` to change the
        // open state.
        onOpenChange: (u, m, f) => {
          f === "escape-key" && t.focus(), u || r.selectThread(void 0), o(u);
        },
        placement: "bottom",
        middleware: [j(10), ce(), Q()]
      },
      elementProps: {
        style: {
          zIndex: 30
        }
      },
      ...e.floatingUIOptions
    }),
    [r, t, n, e.floatingUIOptions]
  ), d = e.floatingThread || en;
  return /* @__PURE__ */ l(Ue, { position: i == null ? void 0 : i.position, ...a, children: s && /* @__PURE__ */ l(d, { thread: s, selected: !0 }) });
}
const ll = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: il
}, Symbol.toStringTag, { value: "Module" })), cl = D.memo(
  ({
    thread: e,
    selectedThreadId: t,
    maxCommentsBeforeCollapse: n,
    referenceText: o
  }) => {
    const r = T(G), i = k(
      (s) => {
        s.target.closest(".bn-action-toolbar") || r.selectThread(e.id);
      },
      [r, e.id]
    ), c = k(
      (s) => {
        if (!s.relatedTarget || s.relatedTarget.closest(".bn-action-toolbar"))
          return;
        const a = s.target instanceof Node ? s.target : null, d = s.relatedTarget instanceof Node ? s.relatedTarget.closest(".bn-thread") : null;
        (!a || !d || !d.contains(a)) && r.selectThread(void 0);
      },
      [r]
    );
    return /* @__PURE__ */ l(
      en,
      {
        thread: e,
        selected: e.id === t,
        referenceText: o,
        maxCommentsBeforeCollapse: n,
        onFocus: i,
        onBlur: c,
        tabIndex: 0
      }
    );
  }
);
function al(e, t, n) {
  if (t === "recent-activity")
    return e.sort(
      (o, r) => r.comments[r.comments.length - 1].createdAt.getTime() - o.comments[o.comments.length - 1].createdAt.getTime()
    );
  if (t === "oldest")
    return e.sort(
      (o, r) => o.createdAt.getTime() - r.createdAt.getTime()
    );
  if (t === "position")
    return e.sort((o, r) => {
      var s, a;
      const i = ((s = n == null ? void 0 : n.get(o.id)) == null ? void 0 : s.from) || Number.MAX_VALUE, c = ((a = n == null ? void 0 : n.get(r.id)) == null ? void 0 : a.from) || Number.MAX_VALUE;
      return i - c;
    });
  throw new xt(t);
}
function Ct(e, t) {
  return e.transact((n) => {
    if (!t)
      return "Original content deleted";
    if (n.doc.nodeSize < t.to)
      return "";
    const o = n.doc.textBetween(
      t.from,
      t.to
    );
    return o.length > 15 ? `${o.slice(0, 15)}…` : o;
  });
}
function Il(e) {
  const t = C(), { selectedThreadId: n, threadPositions: o } = _(G), r = tn(), i = S(() => {
    const c = Array.from(r.values()), s = al(
      c,
      e.sort || "position",
      o
    ), a = [];
    for (const d of s)
      d.resolved ? (e.filter === "resolved" || e.filter === "all") && a.push({
        thread: d,
        referenceText: Ct(
          t,
          o.get(d.id)
        )
      }) : (e.filter === "open" || e.filter === "all") && a.push({
        thread: d,
        referenceText: Ct(
          t,
          o.get(d.id)
        )
      });
    return a;
  }, [r, e.sort, e.filter, o, t]);
  return /* @__PURE__ */ l("div", { className: "bn-threads-sidebar", children: i.map((c) => /* @__PURE__ */ l(
    cl,
    {
      thread: c.thread,
      selectedThreadId: n,
      editor: t,
      referenceText: c.referenceText,
      maxCommentsBeforeCollapse: e.maxCommentsBeforeCollapse
    },
    c.thread.id
  )) });
}
function Pl(e) {
  const t = q();
  if (e || (e = t == null ? void 0 : t.editor), !e)
    throw new Error(
      "'editor' is required, either from BlockNoteContext or as a function argument"
    );
  return R({
    editor: e,
    selector: ({ editor: o }) => o.getActiveStyles()
  });
}
function Nl(e, t) {
  return R({
    editor: t,
    selector: ({ editor: n }) => e ? n.getSelectionBoundingBox() : void 0
  });
}
function sl(e) {
  return e.currentTarget instanceof HTMLElement && e.relatedTarget instanceof HTMLElement ? e.currentTarget.contains(e.relatedTarget) : !1;
}
function Al({
  onBlur: e,
  onFocus: t
} = {}) {
  const n = F(null), [o, r] = M(!1), i = F(!1), c = (d) => {
    r(d), i.current = d;
  }, s = (d) => {
    i.current || (c(!0), t == null || t(d));
  }, a = (d) => {
    i.current && !sl(d) && (c(!1), e == null || e(d));
  };
  return y(() => {
    const d = n.current;
    if (d)
      return d.addEventListener("focusin", s), d.addEventListener("focusout", a), () => {
        d == null || d.removeEventListener("focusin", s), d == null || d.removeEventListener("focusout", a);
      };
  }, [s, a]), { ref: n, focused: o };
}
function Zl(e) {
  return R({
    editor: e,
    selector: ({ editor: t }) => {
      var n;
      return ((n = t.getSelection()) == null ? void 0 : n.blocks) || [t.getTextCursorPosition().block];
    }
  });
}
function Oe(e) {
  return (
    // Creates inline content section element
    /* @__PURE__ */ l(
      Mt,
      {
        as: "span",
        className: "bn-inline-content-section",
        "data-inline-content-type": e.inlineContentType,
        ...Object.fromEntries(
          Object.entries(e.inlineContentProps).filter(([t, n]) => {
            const o = e.propSchema[t];
            return n !== o.default;
          }).map(([t, n]) => [Ht(t), n])
        ),
        children: e.children
      }
    )
  );
}
function Dl(e, t) {
  var o;
  const n = eo.create({
    name: e.type,
    inline: !0,
    group: "inline",
    selectable: e.content === "styled",
    atom: e.content === "none",
    draggable: (o = t.meta) == null ? void 0 : o.draggable,
    content: e.content === "styled" ? "inline*" : "",
    addAttributes() {
      return Wn(e.propSchema);
    },
    addKeyboardShortcuts() {
      return $n(e);
    },
    parseHTML() {
      return jn(
        e,
        t.parse
      );
    },
    renderHTML({ node: r }) {
      const i = this.options.editor, c = tt(
        r,
        i.schema.inlineContentSchema,
        i.schema.styleSchema
      ), s = t.toExternalHTML || t.render, a = Y(
        (d) => /* @__PURE__ */ l(
          s,
          {
            contentRef: (u) => {
              d(u), u && (u.dataset.editable = "");
            },
            inlineContent: c,
            updateInlineContent: () => {
            },
            editor: i
          }
        ),
        i
      );
      return Un(
        a,
        e.type,
        r.attrs,
        e.propSchema
      );
    },
    addNodeView() {
      const r = this.options.editor;
      return (i) => St(
        (c) => {
          const s = Vt().nodeViewContentRef;
          if (!s)
            throw new Error("nodeViewContentRef is not set");
          const a = t.render;
          return /* @__PURE__ */ l(
            Oe,
            {
              inlineContentProps: c.node.attrs,
              inlineContentType: e.type,
              propSchema: e.propSchema,
              children: /* @__PURE__ */ l(
                a,
                {
                  contentRef: (d) => {
                    s(d), d && (d.dataset.editable = "");
                  },
                  editor: r,
                  inlineContent: tt(
                    c.node,
                    r.schema.inlineContentSchema,
                    r.schema.styleSchema
                  ),
                  updateInlineContent: (d) => {
                    const u = zn(
                      [d],
                      r.pmSchema
                    ), m = c.getPos();
                    m !== void 0 && r.transact(
                      (f) => f.replaceWith(m, m + c.node.nodeSize, u)
                    );
                  }
                }
              )
            }
          );
        },
        {
          className: "bn-ic-react-node-view-renderer",
          as: "span"
          // contentDOMElementTag: "span", (requires tt upgrade)
        }
      )(i);
    }
  });
  return qn(
    e,
    {
      ...t,
      node: n,
      render(r, i, c) {
        const s = t.render;
        return Y((d) => /* @__PURE__ */ l(
          Oe,
          {
            inlineContentProps: r.props,
            inlineContentType: e.type,
            propSchema: e.propSchema,
            children: /* @__PURE__ */ l(
              s,
              {
                contentRef: (u) => {
                  d(u), u && (u.dataset.editable = "");
                },
                editor: c,
                inlineContent: r,
                updateInlineContent: i
              }
            )
          }
        ), c);
      },
      toExternalHTML(r, i) {
        const c = t.toExternalHTML || t.render;
        return Y((a) => /* @__PURE__ */ l(
          Oe,
          {
            inlineContentProps: r.props,
            inlineContentType: e.type,
            propSchema: e.propSchema,
            children: /* @__PURE__ */ l(
              c,
              {
                contentRef: (d) => {
                  a(d), d && (d.dataset.editable = "");
                },
                editor: i,
                inlineContent: r,
                updateInlineContent: () => {
                }
              }
            )
          }
        ), i);
      }
    }
  );
}
function Fl(e, t) {
  const n = to.create({
    name: e.type,
    addAttributes() {
      return Xn(e.propSchema);
    },
    parseHTML() {
      return Kn(e);
    },
    renderHTML({ mark: o }) {
      const r = t.render, i = Y(
        (c) => /* @__PURE__ */ l(
          r,
          {
            editor: this.options.editor,
            value: e.propSchema === "boolean" ? void 0 : o.attrs.stringValue,
            contentRef: (s) => {
              c(s), s && (s.dataset.editable = "");
            }
          }
        ),
        this.options.editor
      );
      return Ve(
        i,
        e.type,
        o.attrs.stringValue,
        e.propSchema
      );
    },
    addMarkView() {
      const o = this.options.editor;
      return (r) => {
        const i = no((c) => {
          const s = we(oo).markViewContentRef;
          if (!s)
            throw new Error("markViewContentRef is not set");
          const a = t.render;
          return /* @__PURE__ */ l(
            a,
            {
              editor: o,
              contentRef: (d) => {
                s(d), d && (d.dataset.markViewContent = "");
              },
              value: e.propSchema === "boolean" ? void 0 : c.mark.attrs.stringValue
            }
          );
        })(r);
        return i.didMountContentDomElement = !0, i;
      };
    }
  });
  return Yn(e, {
    ...t,
    mark: n,
    render(o, r) {
      const i = t.render, c = Y(
        (s) => /* @__PURE__ */ l(
          i,
          {
            editor: r,
            value: o,
            contentRef: (a) => {
              s(a), a && (a.dataset.editable = "");
            }
          }
        ),
        r
      );
      return Ve(
        c,
        e.type,
        o,
        e.propSchema
      );
    },
    toExternalHTML(o, r) {
      const i = t.render, c = Y(
        (s) => /* @__PURE__ */ l(
          i,
          {
            editor: r,
            value: o,
            contentRef: (a) => {
              s(a), a && (a.dataset.editable = "");
            }
          }
        ),
        r
      );
      return Ve(
        c,
        e.type,
        o,
        e.propSchema
      );
    }
  });
}
function Gl(e, t) {
  const n = e.getBoundingClientRect(), o = t.getBoundingClientRect(), r = n.top < o.top, i = n.bottom > o.bottom;
  return r && i ? "both" : r ? "top" : i ? "bottom" : "none";
}
function zl(e) {
  return (t) => {
    e.forEach((n) => {
      typeof n == "function" ? n(t) : n != null && (n.current = t);
    });
  };
}
export {
  Or as AddBlockButton,
  ht as AddButton,
  vr as AddCommentButton,
  Cr as AddCommentButtonInner,
  Li as AddFileButton,
  wr as AddTiptapCommentButton,
  Pi as AudioBlock,
  Oi as AudioPreview,
  Ii as AudioToExternalHTML,
  de as BasicTextStyleButton,
  Pr as BlockColorsItem,
  Le as BlockContentWrapper,
  Tt as BlockNoteContext,
  Ci as BlockNoteDefaultUI,
  Ti as BlockNoteViewEditor,
  Hl as BlockNoteViewRaw,
  Bt as BlockPopover,
  pr as BlockTypeSelect,
  ui as ColorPickerButton,
  cr as ColorStyleButton,
  el as Comment,
  tl as Comments,
  io as ComponentsContext,
  sr as CreateLinkButton,
  ii as DeleteButton,
  Tr as DeleteLinkButton,
  Fr as DragHandleButton,
  Dr as DragHandleMenu,
  _r as EditLinkButton,
  $t as EditLinkMenuItems,
  lo as EmbedTab,
  _l as ExperimentalMobileFormattingToolbarController,
  ri as ExtendButton,
  qe as FigureWithCaption,
  Ke as FileBlockWrapper,
  dr as FileCaptionButton,
  ur as FileDeleteButton,
  kr as FileDownloadButton,
  Ri as FileNameWithIcon,
  _t as FilePanel,
  so as FilePanelController,
  Hr as FilePreviewButton,
  mr as FileRenameButton,
  fr as FileReplaceButton,
  nl as FloatingComposer,
  ol as FloatingComposerController,
  il as FloatingThreadController,
  Wt as FormattingToolbar,
  Mr as FormattingToolbarController,
  U as GenericPopover,
  qr as GridSuggestionMenuController,
  Wr as GridSuggestionMenuWrapper,
  Zi as ImageBlock,
  Ni as ImagePreview,
  Ai as ImageToExternalHTML,
  Oe as InlineContentWrapper,
  Er as LinkToolbar,
  Lr as LinkToolbarController,
  Se as LinkWithCaption,
  hr as NestBlockButton,
  Br as OpenLinkButton,
  Ue as PositionPopover,
  xl as ReactAudioBlock,
  yl as ReactFileBlock,
  Sl as ReactImageBlock,
  Ml as ReactVideoBlock,
  Nr as RemoveBlockItem,
  Qt as ResizableFileBlockWrapper,
  Gr as SideMenu,
  zr as SideMenuController,
  mi as SplitButton,
  ni as SuggestionMenuController,
  Qr as SuggestionMenuWrapper,
  hi as TableCellButton,
  fi as TableCellMenu,
  xr as TableCellMergeButton,
  Bl as TableCellPopover,
  Zr as TableColumnHeaderItem,
  di as TableHandle,
  si as TableHandleMenu,
  gi as TableHandlesController,
  Ar as TableRowHeaderItem,
  Ee as TextAlignButton,
  en as Thread,
  Il as ThreadsSidebar,
  Tl as ToggleWrapper,
  gr as UnnestBlockButton,
  co as UploadTab,
  Ui as VideoBlock,
  Gi as VideoPreview,
  zi as VideoToExternalHTML,
  br as blockTypeSelectItems,
  ye as createReactBlockSpec,
  Dl as createReactInlineContentSpec,
  Fl as createReactStyleSpec,
  Gl as elementOverflow,
  Ur as getDefaultReactEmojiPickerItems,
  ti as getDefaultReactSlashMenuItems,
  Sr as getFormattingToolbarItems,
  ao as getMountedBoundingClientRectCache,
  Vl as getPageBreakReactSlashMenuItems,
  Ct as getReferenceText,
  zl as mergeRefs,
  Pl as useActiveStyles,
  q as useBlockNoteContext,
  C as useBlockNoteEditor,
  Kt as useCloseSuggestionMenuNoItems,
  v as useComponentsContext,
  Xe as useCreateBlockNote,
  V as useDictionary,
  vi as useEditorChange,
  Nl as useEditorSelectionBoundingBox,
  wi as useEditorSelectionChange,
  R as useEditorState,
  El as useExtendButtonsPositioning,
  T as useExtension,
  _ as useExtensionState,
  Al as useFocusWithin,
  $r as useGridSuggestionMenuKeyboardNavigation,
  Xt as useLoadSuggestionMenuItems,
  Bi as useOnUploadEnd,
  Ei as useOnUploadStart,
  ki as usePrefersColorScheme,
  We as useResolveUrl,
  Zl as useSelectedBlocks,
  Xr as useSuggestionMenuKeyboardHandler,
  Jr as useSuggestionMenuKeyboardNavigation,
  Ll as useTableHandlesPositioning,
  tn as useThreads,
  Jt as useUploadLoading,
  Yi as useUser,
  Je as useUsers
};
//# sourceMappingURL=blocknote-react.js.map
